<template>
  <!-- 订舱新增、订舱编辑 -->
  <div class="page-container">
 <el-row style="margin-top:18px">
    <el-form class="form-panel" label-position="top"
    >
      <el-row type="flex" justify="start" align="top">
        <el-col :span="10" class="transceiver-module">
          <el-row>
            <eb-party-info
                @getEbPartyInfo="getEbPartyInfo"
                :ebParty.sync="ebParty"
                :ebOrder.sync="ebOrder"
                ref="ebPartyRef"
            />
          </el-row>
          <el-row class="panel-top dock-planner-box">
            <el-col>
              <div class="tab-external">
                    <div class="tab">
                      <span
                          class="tab-item cursor"
                          :class="{ 'tab-active': boxVisible }"
                          @click="boxInfoFn"
                      >预配箱信息</span
                      >
                      <span
                          class="tab-item cursor"
                          :class="{ 'tab-active': !boxVisible }"
                          @click="boxDetailFn"
                      >预配箱明细</span
                      >
                     </div>
                 </div>
              <el-row class="content-panel" id="boxDiv">
                <el-col v-show="boxVisible">
                  <el-row :gutter="1" style="margin:0 0 10px -2px">
                    <el-col :span="10" class="planner-box-btns">
                       <div class="add-button">
                      <el-button
                          type="primary"
                          size="mini"
                          icon="el-icon-circle-plus-outline"
                          circle
                          :disabled="ebOrder.orderStatus === 'SUB' ||
                           ebOrder.orderStatus === 'CRM' ||
                           ebOrder.orderStatus === 'CNL' ||
                           ebOrder.orderStatus === 'UPDSUB'"
                          @click="addNewRow()"
                      >增加</el-button>
                      </div>
                       <div class="synchronous-btn">
                      <el-button
                          type="primary"
                          size="mini"
                          @click="synchronizeToDetail(false)"
                      >同步至预配箱明细
                      </el-button
                      >
                    </div>
                    </el-col>
                  <el-col :span="11" style="padding-left:25px">
                      <span
                          style="
                          padding-left:20px;
                          display: block;
                          width: 100%;
                          word-break: break-word;
                          color: red;
                        "
                      >{{ ebOrder.ctnNum }}</span
                      >
                    </el-col>
                    <el-col :span="3">
                      <el-button
                          size="mini"
                         class="delete-btn"
                          icon="el-icon-delete"
                          :disabled="ebOrder.orderStatus === 'SUB' ||
                           ebOrder.orderStatus === 'CRM' ||
                           ebOrder.orderStatus === 'CNL' ||
                           ebOrder.orderStatus === 'UPDSUB'"
                          @click="batchDeleteEbCtnRequest"
                      ></el-button>
                    </el-col>
                  </el-row>
                  <el-row class="dock-planner-box-container">
                     <el-row class="panel-top dock-planner-box-table">
                    <hot-table
                        ref="ebCtnRequestRef"
                        :data-source="ebCtnRequests"
                        :settings="ebCtnRequestSettings"
                        @cellDblclick="ebCtnRequestCellClick"
                        @rowDblclick="ebCtnRequestRowClick"
                        :rules="ebCtnRequestRules"
                    >
                      <hot-column
                          :has-tip="true"
                          data="ctnQuantity"
                          title="<label style='color:red'>*</label>数量"
                      >
                        <el-input-number-editor
                            :controls="false"
                            :precision="0"
                            :min="0"
                            case="upper"
                            hot-editor
                            name="ctnQuantity"
                        />
                      </hot-column>
                      <hot-column
                          :has-tip="true"
                          data="ctnSizeType"
                          title="<label style='color:red'>*</label>箱型/尺寸"
                      >
                        <el-associate-editor
                            hot-editor
                            style="width: 100%"
                            :columns="associate_columns_ctnSizeType"
                            :query-method="associate_queryMethod_ctnSizeType"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="containerType"
                            value-prop="containerType"
                            placeholder=""
                            size="small"
                            name="ctnSizeType"
                            case="upper"
                        />
                      </hot-column>
                      <hot-column
                          :has-tip="true"
                          data="isSoc"
                          title="SOC"
                          className="htCenter"
                          type="checkbox"
                          :checked-template="1"
                          checked-display="是"
                          :unchecked-template="0"
                          unchecked-display="否"
                          width="50"
                      ></hot-column>
                      <hot-column
                          :has-tip="true"
                          data="isNor"
                          title="冷代平"
                          className="htCenter"
                          type="checkbox"
                          :checked-template="1"
                          checked-display="是"
                          :unchecked-template="0"
                          unchecked-display="否"
                          width="50"
                      ></hot-column>
                      <hot-column
                          :has-tip="true"
                          data="ctnCompanyName"
                          title="箱公司"
                          width="100"
                      >
                        <el-associate-editor
                            hot-editor
                            style="width: 100%"
                            :columns="associate_columns_ctnCompany"
                            :query-method="associate_queryMethod_ctnCompany"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="custNameCn"
                            value-prop="custNameCn"
                            placeholder=""
                            size="small"
                            name="ctnCompanyName"
                            @change="onChangeCtnCompany"
                            case="upper"
                        />
                      </hot-column>
                    </hot-table>
                    </el-row>
                  </el-row>
                </el-col>
                <el-col v-show="!boxVisible">
                <el-row  class="dock-planner-box-container">
                  <hot-table
                      ref="ebCtnRequestDetailRef"
                      :data-source="ebCtnRequestDetails"
                      :settings="ebCtnRequestDetailSettings"
                      @cellDblclick="ebCtnRequestDetailCellClick"
                      @rowDblclick="ebCtnRequestDetailRowClick"
                      :rules="ebCtnRequestDetailRules"
                  >
                    <hot-column
                        :has-tip="true"
                        data="ctnSizeType"
                        title="箱型/尺寸"
                        width="50"
                    ></hot-column>
                    <hot-column
                        :has-tip="true"
                        data="isSoc"
                        title="SOC"
                        className="htCenter"
                        type="checkbox"
                        :checked-template="1"
                        checked-display="是"
                        :unchecked-template="0"
                        unchecked-display="否"
                        width="50"
                    ></hot-column>
                    <hot-column
                        :has-tip="true"
                        data="isNor"
                        title="冷代平"
                        className="htCenter"
                        type="checkbox"
                        :checked-template="1"
                        checked-display="是"
                        :unchecked-template="0"
                        unchecked-display="否"
                        width="50"
                    ></hot-column>
                    <hot-column
                        :has-tip="true"
                        data="noOfPackage"
                        title="件数"
                        width="50"
                    >
                      <el-input-number-editor
                          :controls="false"
                          :precision="0"
                          :min="0"
                          hot-editor
                          name="noOfPackage"
                          case="upper"
                      />
                    </hot-column>
                    <hot-column
                        type="numeric"
                        :numericFormat="{
                        pattern: '0,0.000',
                        culture: 'zh-CN',
                      }"
                        :has-tip="true"
                        data="grossWeight"
                        title="毛重(KGS)"
                        width="50"
                    >
                      <el-input-number-editor
                          :controls="false"
                          :precision="3"
                          :min="0"
                          hot-editor
                          case="upper"
                          name="grossWeight"
                      />
                    </hot-column>
                    <hot-column
                        type="numeric"
                        :numericFormat="{
                        pattern: '0,0.000',
                        culture: 'zh-CN',
                      }"
                        :has-tip="true"
                        data="netWeight"
                        title="净重(KGS)"
                        width="50"
                    >
                      <el-input-number-editor
                          :controls="false"
                          :precision="3"
                          :min="0"
                          hot-editor
                          case="upper"
                          name="netWeight"
                      />
                    </hot-column>
                    <hot-column
                        type="numeric"
                        :numericFormat="{
                        pattern: '0,0.000',
                        culture: 'zh-CN',
                      }"
                        :has-tip="true"
                        data="cube"
                        title="体积(cbm)"
                        width="50"
                    >
                      <el-input-number-editor
                          :controls="false"
                          :precision="3"
                          :min="0"
                          hot-editor
                          case="upper"
                          name="cube"
                      />
                    </hot-column>
                    <hot-column
                        :has-tip="true"
                        data="cargoDescription"
                        title="货物描述"
                        width="100"
                    >
                      <el-input-editor
                          hot-editor
                          case="upper"
                          data="cargoDescription"
                      />
                    </hot-column>
                    <hot-column
                        :has-tip="true"
                        data="marks"
                        title="唛头"
                        width="100"
                    >
                      <el-input-editor hot-editor case="upper" data="marks"/>
                    </hot-column>
                  </hot-table>
               </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
       <el-col :span="14" class="left-margin">
          <el-form
              :disabled="
              ebOrder.orderStatus === 'UPDSUB' ||
              ebOrder.orderStatus === 'SUB' ||
              ebOrder.orderStatus === 'CRM'
            "
              ref="bookingFormRef"
              :rules="bookingFormRules"
              :model="ebOrder"
              class="form-panel"
              label-position="top"
          >
            <!-- 基本信息-start -->
            <div>
              <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">基本信息</span>
                </el-col>
                </div>
              </el-row>
              <el-row class="content-panel">
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-form-item label="订单号:" prop="orderNo">
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.orderNo"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                          label="客户业务编号:"
                          prop="custBizNo"
                          class="redItem"
                      >
                        <el-input
                            size="mini"
                            case="upper"
                            name="custBizNo"
                            v-model="ebOrder.custBizNo"
                            ref="custBizNo"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="提单号:" prop="mblNo">
                        <el-input
                            size="mini"
                            case="upper"
                            name="mblNo"
                            v-model.trim="ebOrder.mblNo"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-form-item
                          label="船公司:"
                          prop="carrierName"
                          class="redItem"
                      >
                        <el-associate
                            style="width: 100%"
                            :columns="associate_columns_carrier"
                            :query-method="associate_queryMethod_carrier"
                            class="input_length"
                            clearable
                            case="upper"
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="custAlias"
                            value-prop="csCustId"
                            placeholder=""
                            v-model="ebOrder.carrierName"
                            size="mini"
                            @change="carrierNameChange"
                            ref="carrierName"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                          label="付款方式:"
                          prop="mblPaymentType"
                          class="redItem"
                      >
                        <el-select
                            class="length_input"
                            size="mini"
                            v-model="ebOrder.mblPaymentType"
                            placeholder="请选择"
                            ref="mblPaymentType"
                        >
                          <el-option
                              v-for="item in mblPaymentTypeList"
                              :key="item.key"
                              :label="item.value"
                              :value="item.key"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="付款地点:" prop="mblPaymentPlace">
                        <el-associate
                            style="width: 100%"
                            :columns="associate_columns_po"
                            :query-method="associate_queryMethod_po"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="portNameEn"
                            value-prop="mdPortId"
                            placeholder=""
                            v-model="ebOrder.mblPaymentPlace"
                            size="mini"
                            @change="changeMblPaymentPlace"
                            case="upper"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-row :gutter="5">
                        <el-col :span="12">
                          <el-form-item
                              label="运输条款:"
                              prop="mblTransportTermFrom"
                              class="redItem"
                          >
                            <el-select
                                class="length_input"
                                size="mini"
                                v-model="ebOrder.mblTransportTermFrom"
                                placeholder="请选择"
                                ref="mblTransportTermFrom"
                            >
                              <el-option
                                  v-for="item in mblTransportTermList"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.key"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-select
                                class="length_input"
                                size="mini"
                                v-model="ebOrder.mblTransportTermTo"
                                placeholder="请选择"
                            >
                              <el-option
                                  v-for="item in mblTransportTermList"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                          label="订舱协议号(S/C NO.):"
                          prop="agreementNo"
                      >
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.agreementNo"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="N/A:" prop="nameAccount">
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.nameAccount"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-form-item
                          label="签单方式:"
                          prop="issueMode"
                          class="redItem"
                          required
                      >
                        <el-select
                            class="length_input"
                            size="mini"
                            @change="changeIssueMode"
                            v-model="ebOrder.issueMode"
                            placeholder="请选择"
                        >
                          <el-option
                              v-for="item in issueModeList"
                              :key="item.key"
                              :label="item.value"
                              :value="item.key"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="签单地点:" prop="placeOfIssueName">
                        <el-associate
                            style="width: 100%"
                            :columns="associate_columns_po"
                            :query-method="associate_queryMethod_po"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="portNameEn"
                            value-prop="mdPortId"
                            placeholder=""
                            v-model="ebOrder.placeOfIssueName"
                            size="mini"
                            @change="changePlaceOfIssueName"
                            case="upper"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-row>
                        <el-col :span="12">
                          <el-form-item
                              label="正本/副本份数:"
                              prop="noOfOriginal"
                              class="redItem"
                              required
                          >
                            <el-select
                                class="length_input"
                                size="mini"
                                v-model="ebOrder.noOfOriginal"
                                placeholder="请选择"
                            >
                              <el-option
                                  v-for="item in noOfOriginalList"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.key"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="noOfCopy">
                            <label slot="label" class="label_no"></label>
                            <el-select
                                class="length_input"
                                size="mini"
                                v-model="ebOrder.noOfCopy"
                                placeholder="请选择"
                            >
                              <el-option
                                  v-for="item in noOfOriginalList"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.key"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-row>
                        <el-col :span="8">
                          <el-form-item label="场内:" prop="freeStorage">
                            <el-input
                                size="mini"
                                case="upper"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                                @change="sumFreeDaysChange"
                                v-model="ebOrder.freeStorage"
                                :min="0"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="场外:" prop="freeOfDetention">
                            <!-- <label slot="label" class="label_no"></label> -->
                            <el-input
                                size="mini"
                                case="upper"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                                @change="sumFreeDaysChange"
                                v-model="ebOrder.freeOfDetention"
                                :min="0"
                            ></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="8">
                          <el-form-item label="免用天数:" prop="freeDays">
                            <el-input
                                size="mini"
                                case="upper"
                                v-model="ebOrder.freeDays"
                                :min="0"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="8">
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="申请方式" prop="">
                            <el-select
                                class="length_input"
                                size="mini"
                                v-model="ebOrder.freeStatus"
                                placeholder="请选择"
                            >
                              <el-option
                                  v-for="item in freeStatus"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.key"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item
                              label="批复状态:"
                              prop="freeApprovalStatus"
                          >
                            <el-select
                                class="length_input"
                                size="mini"
                                v-model="ebOrder.freeApprovalStatus"
                                placeholder="请选择"
                            >
                              <el-option
                                  v-for="item in approvalStatusList"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.key"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="业务类型:" prop="bizTypeName">
                        <el-associate
                            style="width: 100%"
                            :columns="associate_columns_bizTypeName"
                            :query-method="associate_queryMethod_bizTypeName"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="displayValueCn"
                            value-prop="displayValueCn"
                            placeholder=""
                            v-model="ebOrder.bizTypeName"
                            size="mini"
                            @change="changeBizType"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-form-item
                          label="订舱联系人:"
                          prop="custContact"
                          class="redItem"
                      >
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.custContact"
                            ref="custContact"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                          label="订舱联系人电话:"
                          prop="custContactTel"
                      >
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.custContactTel"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                          label="订舱联系人邮箱:"
                          prop="custContactEmail"
                      >
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.custContactEmail"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="20">
                      <el-row>
                        <el-col :span="21">
                          <el-checkbox-group
                              v-model="ebServiceItemList"
                              @change="onChangeEbServiceItem"
                          >
                            <el-checkbox
                                :label="item.key + '/' + item.value"
                                v-for="(item, index) in allEbServiceItems"
                                :key="index"
                            >
                              {{ item.value }}
                            </el-checkbox>
                          </el-checkbox-group>
                        </el-col>
                        <el-col :span="3">
                          <el-checkbox
                              label="拼箱"
                              v-model="ebOrder.isLcl"
                              :true-label="1"
                              :false-label="0"
                              @change="onChangeIsLcl"
                          ></el-checkbox>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col style="margin-top: 8px">
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-form-item
                          label="船公司销售人员:"
                          prop="carrierSales"
                      >
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.carrierSales"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                          label="华贸分公司:"
                          prop="settleOfficeName"
                      >
                        <el-associate
                            style="width: 100%"
                            :columns="associate_columns_csOffice"
                            :query-method="associate_queryMethod_csOffice"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="corpNameCn"
                            value-prop="sysCorpId"
                            placeholder=""
                            v-model="ebOrder.settleOfficeName"
                            size="mini"
                            @change="changeCsOffice"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="华贸客服:" prop="csName">
                        <el-associate
                            style="width: 100%"
                            :columns="associate_columns_csUser"
                            :query-method="associate_queryMethod_csUser"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="salesNameCn"
                            value-prop="salesId"
                            placeholder=""
                            v-model="ebOrder.csName"
                            size="mini"
                            @change="onChangeCsOffice"
                            case="upper"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-form-item label="华贸客服邮箱:" prop="csEmail">
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.csEmail"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="华贸客服电话:" prop="csTel">
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.csTel"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="华贸客服手机:" prop="mobile">
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.mobile"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
            <!-- 船期信息-start -->
            <div class="panel-top">
             <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">船期信息</span>
                </el-col>
                </div>
              </el-row>
              <el-row class="content-panel">
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-row>
                        <el-col :span="16">
                          <el-form-item
                              label="大船船名/航次:"
                              prop="vesselNameEn"
                          >
                            <el-associate
                                style="width: 100%"
                                :columns="associate_columns_vessel"
                                :query-method="associate_queryMethod_vessel"
                                class="input_length"
                                clearable
                                :query-length="0"
                                :default-first-option="true"
                                label-prop="vesselName"
                                value-prop="mdVoyagePlanId"
                                placeholder=""
                                v-model="ebOrder.vesselNameEn"
                                size="mini"
                                @change="onChangeVessel"
                                case="upper"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item prop="voyage">
                            <label slot="label" class="label_no"></label>
                            <el-associate
                                style="width: 100%"
                                :columns="associate_columns_voyage"
                                :query-method="associate_queryMethod_voyage"
                                class="input_length"
                                clearable
                                :query-length="0"
                                :default-first-option="true"
                                label-prop="voyage"
                                value-prop="mdVoyagePlanId"
                                placeholder=""
                                v-model="ebOrder.voyage"
                                size="mini"
                                @change="onChangeVoyage"
                            />
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                          label="大船开航日期:"
                          prop="etd"
                          class="redItem"
                      >
                        <el-date-picker
                            v-model="ebOrder.etd"
                            style="width: 100%"
                            align="right"
                            type="date"
                            size="mini"
                            placeholder="选择日期"
                            :picker-options="pickerOptions"
                            ref="etd"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="作业码头:" prop="terminalName">
                        <el-associate
                            style="width: 100%"
                            :columns="associate_columns_terminal"
                            :query-method="associate_queryMethod_terminal"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="facilityNameCn"
                            value-prop="mdFacilityId"
                            placeholder=""
                            v-model="ebOrder.terminalName"
                            size="mini"
                            @change="onChangeTerminal"
                            case="upper"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-row>
                        <el-col :span="16">
                          <el-form-item label="实装大船船名/航次:">
                            <el-input
                                v-model="ebOrder.realVesselNameEn"
                                size="mini"
                                case="upper"
                                disabled
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                v-model="ebOrder.realVoyage"
                                case="upper"
                                size="mini"
                                disabled
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="实装大船开航日期:" prop="realEtd">
                        <el-date-picker
                            v-model="ebOrder.realEtd"
                            style="width: 100%"
                            align="right"
                            type="date"
                            size="mini"
                            placeholder="选择日期"
                            :picker-options="pickerOptions"
                            :disabled="true"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="船代:">
                        <el-input
                            v-model="ebOrder.shipAgencyName"
                            case="upper"
                            size="mini"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-row>
                        <el-col :span="16">
                          <el-form-item
                              label="驳船船名/航次:"
                              prop="bargeVesselName"
                          >
                            <el-associate
                                style="width: 100%"
                                :columns="associate_columns_vessel"
                                :query-method="associate_queryMethod_vessel"
                                class="input_length"
                                clearable
                                :query-length="0"
                                :default-first-option="true"
                                label-prop="vesselNameEn"
                                value-prop="mdVoyagePlanId"
                                placeholder=""
                                v-model="ebOrder.bargeVesselName"
                                size="mini"
                                @change="onChangeBargeVessel"
                                case="upper"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item prop="bargeVoyage">
                            <label slot="label" class="label_no"></label>
                            <el-associate
                                style="width: 100%"
                                :columns="associate_columns_voyage"
                                :query-method="associate_queryMethod_voyage2"
                                class="input_length"
                                clearable
                                :query-length="0"
                                :default-first-option="true"
                                label-prop="voyage"
                                value-prop="mdVoyagePlanId"
                                placeholder=""
                                v-model="ebOrder.bargeVoyage"
                                size="mini"
                            />
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="驳船开航日期:">
                        <el-date-picker
                            v-model="ebOrder.bargeEtd"
                            style="width: 100%"
                            align="right"
                            type="date"
                            size="mini"
                            placeholder="选择日期"
                            :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                          label="驳船作业码头:"
                          prop="bargeTerminalName"
                      >
                        <el-associate
                            style="width: 100%"
                            :columns="associate_columns_terminal"
                            :query-method="associate_queryMethod_terminal"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="facilityNameCn"
                            value-prop="mdFacilityId"
                            placeholder=""
                            v-model="ebOrder.bargeTerminalName"
                            size="mini"
                            @change="onChangeBargeTerminal"
                            case="upper"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-form-item label="大船截单日期:">
                        <el-date-picker
                            v-model="ebOrder.terminalTime"
                            style="width: 100%"
                            align="right"
                            type="date"
                            size="mini"
                            placeholder="选择日期"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            format="yyyy-MM-dd HH:mm:ss"
                            :disabled="true"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="截VGM:">
                        <el-date-picker
                            v-model="ebOrder.cutVgmTime"
                            style="width: 100%"
                            align="right"
                            type="date"
                            size="mini"
                            placeholder="选择日期"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            format="yyyy-MM-dd HH:mm:ss"
                            :disabled="true"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="截关时间:">
                        <el-date-picker
                            v-model="ebOrder.cutOffTime"
                            style="width: 100%"
                            align="right"
                            type="date"
                            size="mini"
                            placeholder="选择日期"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            format="yyyy-MM-dd HH:mm:ss"
                            :disabled="true"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
            <!-- 港口信息-start -->
        <div class="panel-top">
               <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">港口信息</span>
                </el-col>
                </div>
              </el-row>
              <el-row class="content-panel">
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-row :gutter="5">
                        <el-col :span="8">
                          <el-form-item label="收货地:" prop="porName">
                            <el-associate
                                style="width: 100%"
                                :columns="associate_columns_po"
                                :query-method="associate_queryMethod_po"
                                class="input_length"
                                clearable
                                :query-length="0"
                                :default-first-option="true"
                                label-prop="portCode"
                                value-prop="portCode"
                                placeholder=""
                                v-model="ebOrder.porCode"
                                size="mini"
                                @change="onChangePor"
                                case="upper"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="16">
                          <el-form-item prop="porCode">
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                v-model="ebOrder.porName"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="12">
                      <el-row :gutter="5">
                        <el-col :span="8">
                          <el-form-item
                              label="装货港:"
                              prop="polCode"
                              class="redItem"
                          >
                            <el-associate
                                style="width: 100%"
                                :columns="associate_columns_po"
                                :query-method="associate_queryMethod_po"
                                class="input_length"
                                clearable
                                :query-length="0"
                                :default-first-option="true"
                                label-prop="portCode"
                                value-prop="portCode"
                                placeholder=""
                                v-model="ebOrder.polCode"
                                size="mini"
                                @change="onChangePol"
                                case="upper"
                                ref="polCode"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="16">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                v-model="ebOrder.polName"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-row :gutter="5">
                        <el-col :span="8">
                          <el-form-item label="中转港:" prop="potName">
                            <el-associate
                                style="width: 100%"
                                :columns="associate_columns_po"
                                :query-method="associate_queryMethod_po"
                                class="input_length"
                                clearable
                                :query-length="0"
                                :default-first-option="true"
                                label-prop="portCode"
                                value-prop="portCode"
                                placeholder=""
                                v-model="ebOrder.potCode"
                                size="mini"
                                @change="onChangePot"
                                case="upper"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="16">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                v-model="ebOrder.potName"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="12">
                      <el-row :gutter="5">
                        <el-col :span="8">
                          <el-form-item
                              label="卸货港:"
                              prop="podCode"
                              :required="true"
                              class="redItem"
                          >
                            <el-associate
                                style="width: 100%"
                                :columns="associate_columns_po"
                                :query-method="associate_queryMethod_po"
                                class="input_length"
                                clearable
                                :query-length="0"
                                :default-first-option="true"
                                label-prop="portCode"
                                value-prop="portCode"
                                placeholder=""
                                v-model="ebOrder.podCode"
                                size="mini"
                                @change="onChangePod"
                                case="upper"
                                ref="podCode"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="16">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                v-model="ebOrder.podName"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-row :gutter="5">
                        <el-col :span="8">
                          <el-form-item
                              label="交货地:"
                              prop="placeOfDeliveryCode"
                              class="redItem"
                          >
                            <el-associate
                                style="width: 100%"
                                :columns="associate_columns_po"
                                :query-method="associate_queryMethod_po"
                                class="input_length"
                                clearable
                                :query-length="0"
                                :default-first-option="true"
                                label-prop="portCode"
                                value-prop="portCode"
                                placeholder=""
                                v-model="ebOrder.placeOfDeliveryCode"
                                size="mini"
                                @change="onChangePlaceOfDelivery"
                                case="upper"
                                ref="placeOfDeliveryCode"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="16">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                v-model="ebOrder.placeOfDeliveryName"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                          label="进港代码:"
                          prop="bargeTransitPortCode"
                      >
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.bargeTransitPortCode"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
       </div>
          </el-form>
     </el-col>
      </el-row>
      <!-- 货物信息与货物小计-start -->
      <el-row type="flex" justify="start" align="top">
        <el-col>
          <eb-cargo-info
              @getCargoInfo="getEbCargoInfo"
              :ebCargo.sync="ebCargo"
              :ebOrder.sync="ebOrder"
              ref="ebCargoRef"
          />
        </el-col>
      </el-row>
      <!-- 货物信息与货物小计-end -->
      <el-row type="flex" justify="start" align="top" class="panel-top" style="margin-top:18px">
        <el-col>
          <el-row :gutter="10">
            <el-col :span="10">
              <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">船公司扩展信息</span>
                </el-col>
                </div>
              </el-row>
              <el-row class="content-panel" style="min-height: 200px;margin-bottom:0px">
                  <el-col v-if="carrierExpand.length > 0">
                  <el-row :gutter="10">
                    <el-col
                        :span="12"
                        v-for="(widgetItem, index) in carrierExpand"
                        :key="index"
                    >
                      <el-form-item
                          :label="widgetItem.fieldName"
                          v-if="widgetItem.controlType === '01'"
                      >
                        <el-select
                            class="length_input"
                            size="mini"
                            v-model="bookingForm[widgetItem.fieldCode]"
                            placeholder="请选择"
                            case="upper"
                        >
                          <el-option
                              v-for="item in carrierSelectList[
                              widgetItem.controlBindCode
                            ]"
                              :key="item.key"
                              :label="item.value"
                              :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                          :label="widgetItem.fieldName"
                          v-if="widgetItem.controlType === '02'"
                      >
                        <el-input
                            size="mini"
                            v-model="bookingForm[widgetItem.fieldCode]"
                            placeholder="请输入"
                            case="upper"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                 </el-col>
                <el-col class="icon-wrp" v-else>
                     <img  class="icon-none-info" :src="icon_none_info" alt="" />
                      <div class="txt-none-info">暂无船公司扩展信息</div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="14" style="padding-right:5px">
              <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">备注信息</span>
                </el-col>
                </div>
              </el-row>
              <el-row class="content-panel" style="margin-bottom:0px;min-height: 200px;">
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="客户备注:">
                        <el-input
                         style="margin-top:5px"
                            size="mini"
                            type="textarea"
                            case="upper"
                            :rows="7"
                            :disabled="
                            ebOrder.orderStatus === 'UPDSUB' ||
                            ebOrder.orderStatus === 'SUB' ||
                            ebOrder.orderStatus === 'CRM'
                          "
                            v-model="ebOrder.orderRemark"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="订舱反馈备注:">
                        <el-input
                         style="margin-top:5px"
                            size="mini"
                            type="textarea"
                            :rows="7"
                            case="upper"
                            disabled
                            v-model="ebOrder.bookingFeedback"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <el-row
        class="btn-container panel-top"
        type="flex"
        justify="end"
        align="middle"
    >
      <el-button
          type="primary"
          size="mini"
          @click="makeBLN"
          v-if="ebOrder.orderStatus === 'CRM'"
          v-preventReClick
      >制作提单
      </el-button
      >
      <el-button
          type="primary"
          size="mini"
          @click="makeManifest"
          v-if="ebOrder.orderStatus === 'CRM'"
          v-preventReClick
      >制作舱单
      </el-button
      >
      <el-button
          type="primary"
          size="mini"
          @click="saveNew(2)"
          v-if="ebOrder.orderStatus === 'NEW' || ebOrder.orderStatus === 'REJ'"
          v-preventReClick
      >暂存草稿
      </el-button
      >
      <el-button
          type="primary"
          size="mini"
          @click="saveNew(3)"
          v-if="ebOrder.orderStatus === 'NEW' || ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'REJ'"
          v-preventReClick
      >提交
      </el-button
      >
      <!-- <el-button type="primary" size="mini" @click="saveTemplate">存为模板</el-button> -->
      <el-button
          type="primary"
          size="mini"
          @click="cancelSubmit"
          v-if="ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB'"
          v-preventReClick
      >撤销提交
      </el-button
      >
      <el-button
          type="primary"
          size="mini"
          @click="changeHistory"
          v-preventReClick
          v-if="ebOrder.ebOrderStatus !== '' "
      >改配历史
      </el-button
      >
      <el-button
          type="primary"
          size="small"
          plain
          @click="invoiceQuery"
          v-if="ebOrder.orderStatus === 'CRM'"
      >发票查询
      </el-button>
      <!--<el-button type="primary" size="mini" @click="close">关闭</el-button>-->
      <save_template_up_box
          :save-template-visible-flag-init="saveTemplateVisible"
          :allBookingDTO="allBookingDTO"
      />
      <change_history_up_box
          :change-history-visible-flag-init="changeHistoryVisible"
          :ebOrder="ebOrder"
      />
    </el-row>
 </el-row>
  </div>
</template>

<script>
import ebOrder from "@/api/ebOrder";
import { queryMdCarrierInfo } from '@/api/queryMainSystem'
import ebCargoInfo from "@/components/EbCargoInfo/EbCargoInfo";
import ebPartyInfo from "@/components/EbPartyInfo/EbPartyInfo";
import {
  deleteEbCtnRequest,
  getBookingVO,
  getEbServiceItem,
  getOrderdata,
  publicSave,
  publicSubmit,
  revokeSub,
  saveAndSub,
  saveBookingDTO,
} from "@/api/bookingRequest";
import {
  querybizTypeName,
  queryCarrierInfo,
  queryCtnCompanyInfo,
  queryCtnSizeInfo,
  queryDictRows,
  queryPoInfo,
  querySales,
  queryVoyageInfo,
} from "@/api/commonService";
import { querySpOrderStatus } from "@/api/status";
import mdCodeDict from "@/api/mdCodeDict";
import { ebCtnRequestValidate } from "@/rules/rules";
import saveTemplateUpBox from "@/views/booking/SaveTemplateUpBox";
import changeHistoryUpBox from "@/views/booking/ChangeHistoryUpBox";
import sysCorpCust from "@/api/sysCorpCust";
import ScrollPane from "@/layout/components/TagsView/ScrollPane";
import ebParty from "@/api/ebParty";
import autoFocusMixin from "@/mixin/autoFocus"

export default {
  name: "bookingEdit",
  components: {
    ebCargoInfo,
    ebPartyInfo,
    ScrollPane,
    save_template_up_box: saveTemplateUpBox,
    change_history_up_box: changeHistoryUpBox,
  },
  mixins: [autoFocusMixin],
  data() {
    return {
        icon_none_info: require("../../assets/images/dashboard_imgs/shipping-company.png"),
      watchCarrierExpand: 0,
      axisStatusList: [
        {
          index: "2",
          text: ["订舱草稿", null],
          iconStatus: {
            0: require("@/assets/img/status/status9.png"),
            2: require("@/assets/img/status/status1.png"),
          },
        },
        {
          index: "0",
          text: ["订舱未提交", null],
          iconStatus: {
            0: require("@/assets/img/status/status8.png"),
            2: require("@/assets/img/status/status2.png"),
          },
        },
        {
          index: "0",
          text: ["订舱未成功", null],
          iconStatus: {
            0: require("@/assets/img/status/status7.png"),
            2: require("@/assets/img/status/status3.png"),
          },
        },
        {
          index: "0",
          text: ["未发送舱单", null],
          iconStatus: {
            0: require("@/assets/img/status/status6.png"),
            2: require("@/assets/img/status/status4.png"),
          },
        },
        {
          index: "0",
          text: ["未做提单确认", null],
          iconStatus: {
            0: require("@/assets/img/status/status5.png"),
            2: require("@/assets/img/status/status9.png"),
          },
        },
      ],
      ebOrderType: null,
      // 记录进入页面次数
      bookingCount: 0,
      //存为模板弹出框
      saveTemplateVisible: false,
      //改配历史弹出框
      changeHistoryVisible: false,
      //所有的格式化订舱数据
      allBookingDTO: {},
      //服务项勾选
      ebServiceItemList: [],
      //订单
      ebOrder: {
        jsonInfo: '',
        synchronizeToDetail: false,
        mblTransportTermFrom: "CY",
        mblTransportTermTo: "CY",
        issueMode: "O", //正本提单
        noOfOriginal: "3", //THREE(3)
        noOfCopy: "0", //ZERO(0)
        freeApprovalStatus: "NA", //批复状态
        custContact: "",
        custContactTel: "",
        custContactEmail: "",
        orderStatus: "NEW",
        ebOrderStatus: "",
        bizTypeCode: "MFEF",
        bizTypeName: "海运整箱出口",
        bizBigTypeCode: "",
        bizBigTypeName: "",
        inputMethond: "M",
        orderType: "F",
        isCancelApply: 0,
        // custId: "1",//登录人的委托单位
        // custName: "",//登录人的委托单位
        isLcl: 0,
        carrierId: "", //根据对话框中选择的船公司赋值?
        carrierName: "", //根据对话框中选择的船公司赋值?
        isDeleted: 0,
        vgmStatus: "UNSENT",
        vgmApprovalStatus: "NEW",
        transferStatus: 0,
        rowStatus: 4,
        ctnNum: "",
        settleOfficeName: "",
        settleOffice: "",
        voyage: "",
        bargeVoyage: "",
        mblPaymentType: "",
        mblPaymentPlace: "",
        placeOfIssueName: "",
        freeStorage: "",
        freeOfDetention: "",
        freeStatus: "NA",
        carrierSales: "",
        porName: "",
        polName: "",
        podName: "",
        // ssss
        polCode: "",
        podCode: "",
        placeOfDeliveryCode: "",
        potName: "",
        placeOfDeliveryName: "",
        bargeTransitPortCode: "",
        bookingFeedback: "",
        orderRemark: "",
        cutOffTime: "",
        cutVgmTime: "",
        shipAgencyName: "",
        shipAgencyId: "",
        csName: "",
        csId: "",
        csEmail: "",
        csTel: "",
        mobile: ""
      },
      //货物信息
      ebCargo: {
        ebCargoD: [],
        ebCargoM: {
          totalFlag: "M",
          isHazard: 0,
          isReefer: 0,
          isBulkyCargo: 0,
          isDeclare: 0,
          isOceanPollution: 0,
          rowStatus: 4,
          hazardClass: "1.1",
          flashPointUnit: "C",
          temperatureUnit: "C",
        },
        //删除的ebCargo
        ebCargoDelete: [],
      },
      //预配箱
      ebCtnRequests: [],
      //预配箱明细
      ebCtnRequestDetails: [],
      //服务项
      ebServiceItems: [],
      //收发通信息
      ebParty: {
        //发货人
        ebPartySH: { partyType: "SH", rowStatus: 4, partyDescription: "" },
        //收获人
        ebPartyCN: { partyType: "CN", rowStatus: 4, partyDescription: "" },
        //通知人
        ebPartyNT: { partyType: "NT", rowStatus: 4, partyDescription: "" },
        //第二通知人
        ebPartyNT2: { partyType: "NT2", rowStatus: 4 },
        //真实发货人
        ebPartyRSH: { partyType: "RSH", rowStatus: 4 },
        //真实收获人
        ebPartyRCN: { partyType: "RCN", rowStatus: 4 },
        //真实通知人
        ebPartyRNT: { partyType: "RNT", rowStatus: 4 },
      },
      //删除的ebCtnRequestDetail
      ebCtnRequestDetailDelete: [],
      //删除的ebCtnRequest
      ebCtnRequestDelete: [],
      //付款方式
      mblPaymentTypeList: [],
      //运输条款
      mblTransportTermList: [],
      //签单方式
      issueModeList: [],
      //正本份数、副本份数
      noOfOriginalList: [],
      //免用箱申请方式/批复状态
      approvalStatusList: [],
      // 状态
      freeStatus: [],
      //所有的服务项
      allEbServiceItems: [],
      //华贸分公司联想控件
      associate_columns_csOffice: [
        {
          title: "代码",
          field: "sysCorpId",
        },
        // {
        //   title: "公司简称",
        //   field: "corpName",
        // },
        {
          title: "中文全称",
          field: "corpNameCn",
        },
      ],
      //业务要素联想控件
      associate_columns_bizTypeName: [
        {
          title: "业务类型",
          field: "displayValueCn",
        },
        {
          title: "业务类型代码",
          field: "codeValue",
        },
      ],
      //华贸客服联想控件
      associate_columns_csUser: [
        {
          title: "中文名称",
          field: "salesNameCn",
        },
        {
          title: "英文名称",
          field: "salesNameEn",
        },
      ],
      //箱型联想控件
      associate_columns_ctnSizeType: [
        {
          title: "箱型尺寸",
          field: "containerType",
        },
      ],
      //箱公司联想控件
      associate_columns_ctnCompany: [
        {
          title: "客商简称",
          field: "custAlias",
        },
        {
          title: "客商全称",
          field: "custNameCn",
        },
        {
          title: "助记码",
          field: "mnemonicCode",
        },
      ],
      //大船/驳船船名联想控件
      associate_columns_vessel: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
      ],
      //航次联想控件
      associate_columns_voyage: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
        {
          title: "航次代码",
          field: "voyageCode",
        },
      ],
      //(驳船)作业码头联想控件
      associate_columns_terminal: [
        {
          title: "码头简称",
          field: "shortName",
        },
        {
          title: "助记码",
          field: "mnemonicCode",
        },
        {
          title: "码头全称",
          field: "facilityNameCn",
        },
      ],
      //收货地/装货港/中转港/卸货港/交货地联想控件
      associate_columns_po: [
        {
          title: "英文名称",
          field: "portNameEn",
        },
        {
          title: "中文名称",
          field: "portNameCn",
        },
        {
          title: "国家代码",
          field: "countryCode",
        },
        {
          title: "海港代码",
          field: "portCode",
        },
      ],
      //表单校验
      bookingFormRules: {
        custBizNo: [
          {
            required: true,
            message: "客户业务编号不能为空",
            trigger: ["blur", "change"],
          },
        ],
        carrierName: [
          {
            required: true,
            message: "船公司不能为空",
            trigger: ["blur", "change"],
          },
        ],
        mblPaymentType: [
          {
            required: true,
            message: "付款方式不能为空",
            trigger: ["blur", "change"],
          },
        ],
        mblTransportTermFrom: [
          {
            required: true,
            message: "运输条款不能为空",
            trigger: ["blur", "change"],
          },
        ],
        custContact: [
          {
            required: true,
            message: "订舱联系人不能为空",
            trigger: ["blur", "change"],
          }
        ],
        etd: [
          {
            required: true,
            message: "大船开船日期不能为空",
            trigger: ["blur", "change"],
          },
        ],
        polCode: [
          {
            required: true,
            message: "装货港不能为空",
            trigger: ["blur", "change"],
          },
        ],
        podCode: [
          {
            required: true,
            message: "卸货港不能为空",
            trigger: ["blur", "change"],
          },
        ],
        placeOfDeliveryCode: [
          {
            required: true,
            message: "交货地不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      boxVisible: true,
      moreInfoVisible: false,
      bookingForm: {},
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      // 预配箱信息
      ebCtnRequestRules: {}, //预配箱信息校验规则
      // 预配箱信息表格配置
      ebCtnRequestSettings: {
        height: 130,
        autoColumnSize: true,
        stretchH: "none", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        afterChange: this.afterChangeEbCtnRequest,
        ...this.$systemConfig.tableConfig,
      },
      ebCtnRequestDetailRules: {}, //预配箱明细校验规则
      // 预配箱明细表格配置
      ebCtnRequestDetailSettings: {
        height: 170,
        autoColumnSize: true,
        stretchH: "none", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        afterChange: this.afterChangeEbCtnRequestDetail,
        ...this.$systemConfig.tableConfig,
      },
      cargoInfoForm: {
        checkList: [],
        shippingMark: "父向子传值", //唛头
        cargoDetail: "", //货物描述
        pieces: "",
        package: "",
        grossWeight: "", //毛重
        volume: "", //体积
        netWeight: "", //净重
        hsCode: "",
        cargoInfoArr: [0],
      },
      // Json
      eiOrderJson: {},
      isSaveNew: false,
      ebParams: {},
      saveNewVisible: false,
      submitVisible: false,
      // 船公司
      associate_columns_carrier: [
        {
          title: "客商简称",
          field: "custAlias",
        },
        {
          title: "客商全称",
          field: "custNameCn",
        },
        {
          title: "助记码",
          field: "mnemonicCode",
        },
      ],
      carrierExpand: [],
      carrierSelectList: {},
      ebServiceItemsBuffer: [],
      // 分页
      pageConfig: {
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        pageSize: 10,
        pagerCount: 10,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
      },
      _index: 0,
    };
  },
  computed: {
    computedEbOrder() {
      return JSON.stringify(this.ebOrder);
    },
  },
  watch: {
    computedEbOrder: {
      handler(newValue, oldValue) {
        let newEbOrder = JSON.parse(newValue);
        if (newEbOrder.rowStatus === 2) {
          this.ebOrder.rowStatus = 16;
        }
      },
    },
    "ebOrder.carrierId": function () {
      let self = this
      if (this.ebOrder.carrierId && this.ebOrder.settleOffice) {
        let params = {
          carrierId: this.ebOrder.carrierId,
          settleOffice: this.ebOrder.settleOffice,
          businessType: "BK",
          currentPage: 1,
          pageSize: 100
        };
        queryMdCarrierInfo(params).then((res) => {
          if (res.records.records.length === 0) {
            self.carrierExpand = []
            return
          }
          let dicParams = []
          self.bookingForm = {}
          res.records.records.forEach((el) => {
            let isCarrierExpandPushed = self.carrierExpand.find(item => item.fieldCode === el.fieldCode)
            if (isCarrierExpandPushed) return
            self.$set(self.bookingForm, el.fieldCode, null)
            self.carrierExpand.push(el);
            if (el.controlType === "01") {
              dicParams.push(el.controlBindCode);
            }
          });
          self.getCarrierSelectList(dicParams.toString());
          //当首次进入时，查询到扩展信息后要将原数据中的数值赋值到相应的字段中
          if (self.watchCarrierExpand === 0 || self.watchCarrierExpand === 1) {
            for (let key in self.ebOrder.jsonInfo) {
              if (self.ebOrder.jsonInfo[key]) {
                self.bookingForm[key] = self.ebOrder.jsonInfo[key]
              }
            }
            self.watchCarrierExpand++
          }
          self.$forceUpdate();
        });
      }
    },
    "ebOrder.settleOffice": function () {
      let self = this
      if (this.ebOrder.carrierId && this.ebOrder.settleOffice) {
        let params = {
          carrierId: this.ebOrder.carrierId,
          settleOffice: this.ebOrder.settleOffice,
          businessType: "BK",
          currentPage: 1,
          pageSize: 100
        };
        queryMdCarrierInfo(params).then((res) => {
          if (res.records.records.length === 0) {
            self.carrierExpand = []
            return
          }
          let dicParams = []
          self.bookingForm = {}
          res.records.records.forEach((el) => {
            let isCarrierExpandPushed = self.carrierExpand.find(item => item.fieldCode === el.fieldCode)
            if (isCarrierExpandPushed) return
            self.$set(self.bookingForm, el.fieldCode, null)
            self.carrierExpand.push(el);
            if (el.controlType === "01") {
              dicParams.push(el.controlBindCode);
            }
          });
          self.getCarrierSelectList(dicParams.toString());
          //当首次进入时，查询到扩展信息后要将原数据中的数值赋值到相应的字段中
          if (self.watchCarrierExpand === 0 || self.watchCarrierExpand === 1) {
            for (let key in self.ebOrder.jsonInfo) {
              if (self.ebOrder.jsonInfo[key]) {
                self.bookingForm[key] = self.ebOrder.jsonInfo[key]
              }
            }
            self.watchCarrierExpand++
          }
          self.$forceUpdate();
        });
      }
    },
  },
  async created() {

    let self = this;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    let params = {
      page: self.pageConfig.currentPage,
      limit: self.pageConfig.pageSize,
      csCustId: userInfo.custId,
    };
    let keyword = "";
    if (keyword !== "") {
      params.corpNameCn = keyword;
    }
    // test for zhang
    return new Promise((resolve) => {
      sysCorpCust.getsysCorpCustCsOffice(params).then((res) => {
        if (res.data.totalRecord === 1) {
          self.ebOrder.settleOfficeName = res.data.data[0].corpNameCn;
        }
        resolve({
          records: res.data.data,
          total: res.data.length,
        });
      });
    }).catch((err) => {
      console.log(err);
    });
  },
  mounted() {
    let _this = this;
    let config = {
      nextKey: { ctrl: false, shift: false, alt: false, key: "tab" },
    };
    _this.$tabIndex.register(_this, config);
    _this.ebOrderType = sessionStorage.getItem("ebOrderType");
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    _this.ebOrder.settleOffice = userInfo.settleOfficeId;
    _this.ebOrder.custContact = userInfo.userNameCn;
    /**/
    let data = {
      sysUserId: userInfo.userId
    };
    _this.getUser(data);
    //数据字典
    _this.getSelectList();
    //预配箱信息表格校验
    _this.ebCtnRequestRules = ebCtnRequestValidate();
    _this.ebCtnRequestDetailRules = ebCtnRequestValidate();
    //表格响应式
    _this.resizeObserver = new ResizeObserver((entries) => {
      _this.$nextTick(() => {
        if (this.boxVisible) {
          _this.$refs.ebCtnRequestRef.resizeTo(
              entries[0].target.clientWidth - 19
          );
        } else {
          _this.$refs.ebCtnRequestDetailRef.resizeTo(
              entries[0].target.clientWidth - 19
          );
        }
      });
    });
    _this.resizeObserver.observe(document.getElementById("boxDiv"));
    /**跳转到此界面接收值**/
    if (this.$route.params.ebOrder) {
      _this.ebOrder = this.$route.params.ebOrder;
      console.log("_this.ebOrder:", _this.ebOrder);
      //订舱管理-编辑
      if (_this.ebOrder.ebOrderId !== undefined) {
        _this.getBookingDataByEbOrderIdAndFlag(_this.ebOrder.ebOrderId, 1);
      } else if (_this.ebOrder.copyFlag === 1) {
        _this.getBookingDataByEbOrderIdAndFlag(_this.ebOrder.ebOrderId, 0);
      }
    }
    //订舱管理-模板订舱
    if (this.$route.params.allData !== undefined) {
      console.log("this.$route.params.allData:", this.$route.params.allData);
      let allData = this.$route.params.allData;
      _this.ebOrder = allData.ebOrder;
      let ebCargos = allData.ebCargos;
      _this.ebCargo.ebCargoD = ebCargos.filter((ebCargo) => {
        return ebCargo.totalFlag === "D";
      });
      _this.ebCargo.ebCargoM = ebCargos.filter((ebCargo) => {
        return ebCargo.totalFlag === "M";
      })[0];
      console.log("_this.ebCargo", _this.ebCargo);
      console.log("_this.ebParties", allData.ebParties);
      let ebParties = allData.ebParties;
      _this.ebParty.ebPartySH = ebParties.filter((ebParty) => {
        return ebParty.partyType === "SH";
      })[0];
      _this.ebParty.ebPartyCN = ebParties.filter((ebParty) => {
        return ebParty.partyType === "CN";
      })[0];
      _this.ebParty.ebPartyNT = ebParties.filter((ebParty) => {
        return ebParty.partyType === "NT";
      })[0];
      _this.ebParty.ebPartyNT2 = ebParties.filter((ebParty) => {
        return ebParty.partyType === "NT2";
      })[0];
      _this.ebParty.ebPartyRSH = ebParties.filter((ebParty) => {
        return ebParty.partyType === "RSH";
      })[0];
      _this.ebParty.ebPartyRCN = ebParties.filter((ebParty) => {
        return ebParty.partyType === "RCN";
      })[0];
      _this.ebParty.ebPartyRNT = ebParties.filter((ebParty) => {
        return ebParty.partyType === "RNT";
      })[0];
      console.log("_this.ebParty", _this.ebParty);
      _this.ebCtnRequests = allData.ebCtnRequests;
      _this.ebCtnRequestDetails = allData.ebCtnRequestDetails;
      _this.ebServiceItems = allData.ebServiceItems;
    }
    // 复制
    let ebOrderParams = JSON.parse(sessionStorage.getItem("ebOrderParams"));
    let ebOrderType = sessionStorage.getItem("ebOrderType");
    if (ebOrderParams.custBizNo !== null && ebOrderParams[0].ebOrderId) {
      _this.getOrder(ebOrderParams[0].ebOrderId, ebOrderType);
    }
    if (_this.ebOrder.csName === "") {
      _this.getSales();
    }
  },
  methods: {
    validateAutoFocus() {
      this.autoFocus(this.ebOrder, this.bookingFormRules);
    },
    getSales() {
      let self = this;
      let params = {
        currentPage: 1,
        pageSize: 100,
        isDefault: 1
      };
      querySales(params).then(res => {
        if (res.records !== null) {
          self.ebOrder.csName = res.records[0].salesNameCn;
          self.ebOrder.csId = res.records[0].salesId;
          self.ebOrder.csEmail = res.records[0].email;
          self.ebOrder.csTel = res.records[0].tel;
          self.ebOrder.mobile = res.records[0].mobileNo;
        }
      })
    },
    getUser(data) {
      let self = this;
      ebOrder.searchUser(data)
          .then((res) => {
            if (res.success) {
              self.ebOrder.custContactEmail = res.records.email;
              self.ebOrder.custContactTel = res.records.tel;
            }
          });
    },
    // 发票查询
    invoiceQuery() {
      console.log('发票查询')
      let self = this;
      let params = self.ebOrder;
      if (params.mblNo === null) {
        self.$coreMethods.message("warning", "mblNo不能为空");
        return;
      }
      self.$router.push({
        name: 'orderInvoiceDetails',
        params: {
          mblNo: params.mblNo,
          goOrderId: params.goOrderId,
          type: "manage",
        },
      })
    },
    getOrder(ebOrderId, ebOrderType) {
      let _this = this;
      getOrderdata({ ebOrderId: ebOrderId }).then((res) => {
        if (res.success) {
          if (ebOrderType === "edit") {
            _this.ebCargo.ebCargoD = [];
            _this.ebOrder = res.records;
            _this.ebOrder.noOfOriginal = _this.ebOrder.noOfOriginal.toString();
            _this.ebOrder.noOfCopy = _this.ebOrder.noOfCopy.toString();
            _this.ebCtnRequests = _this.ebOrder.ebCtnRequests;
            _this.ebCtnRequestDetails = res.records.ebCtns;
            let checkedArr = [];
            if (_this.ebOrder.ebServiceItems &&
                _this.ebOrder.ebServiceItems.length > 0) {
              _this.ebOrder.ebServiceItems.forEach((el, index) => {
                checkedArr.push(el.serviceCode + "/" + el.serviceName);
              });
            }
            _this.ebServiceItemList = checkedArr;
            _this.ebServiceItemsBuffer = res.records.ebServiceItems;
            _this.ebPartys = {};
            res.records.ebPartys.forEach((el) => {
              // delete el.ebOrderId;
              el.rowStatus = 16;
              _this.ebPartys["ebParty" + el.partyType] = el;
            });
            _this.ebParty = _this.ebPartys;
            _this.ebParams.ebPartys = _this.ebPartys;
            if (res.records.ebCargos.length > 1) {
              res.records.ebCargos.forEach((el) => {
                if (el.totalFlag === "M") {
                  el.rowStatus = 16;
                  // delete el.ebOrderId;
                  _this.ebCargo.ebCargoM = el;
                } else {
                  el.rowStatus = 16;
                  // delete el.ebOrderId;
                  _this.ebCargo.ebCargoD.push(el);
                }
              });
            }
            _this.ebParams.ebCargos = _this.ebCargo;
          }
          if (ebOrderType === "copy") {
            _this.ebOrderType = "copy";
            res.records.mblPaymentType ?
                (_this.ebOrder.mblPaymentType = res.records.mblPaymentType.toString()) :
                (_this.ebOrder.mblPaymentType = "");
            _this.ebOrder.mblPaymentPlace = res.records.mblPaymentPlace;
            _this.ebOrder.mblTransportTermFrom = res.records.mblTransportTermFrom;
            _this.ebOrder.mblTransportTermTo = res.records.mblTransportTermTo;
            res.records.issueMode ?
                (_this.ebOrder.issueMode = res.records.issueMode.toString()) :
                (_this.ebOrder.issueMode = "");
            _this.ebOrder.placeOfIssueName = res.records.placeOfIssueName;
            res.records.noOfOriginal = _this.ebOrder.noOfOriginal ? res.records.noOfOriginal.toString() : "";
            res.records.noOfCopy = _this.ebOrder.noOfCopy ? res.records.noOfCopy.toString() : "";
            _this.ebOrder.freeStorage = res.records.freeStorage;
            _this.ebOrder.freeOfDetention = res.records.freeOfDetention;
            _this.ebOrder.freeDays = res.records.freeDays;
            _this.ebOrder.freeStatus = res.records.freeStatus;
            _this.ebOrder.carrierSales = res.records.carrierSales;
            _this.ebOrder.porName = res.records.porName;
            _this.ebOrder.porCode = res.records.porCode;
            _this.ebOrder.polName = res.records.polName;
            _this.ebOrder.polCode = res.records.polCode;
            _this.ebOrder.podName = res.records.podName;
            _this.ebOrder.podCode = res.records.podCode;
            _this.ebOrder.potName = res.records.potName;
            _this.ebOrder.potCode = res.records.potCode;
            _this.ebOrder.placeOfDeliveryName = res.records.placeOfDeliveryName;
            _this.ebOrder.bargeTransitPortCode = res.records.bargeTransitPortCode;
            _this.ebOrder.bookingFeedBack = res.records.bookingFeedBack;
            _this.ebOrder.orderRemark = res.records.orderRemark;
            _this.ebOrder = res.records;
            _this.ebOrder.bookingFeedback = null;
            let checkedArr = [];
            _this.ebOrder.ebServiceItems = res.records.ebServiceItems;
            _this.ebOrder.orderStatus = "NEW";
            _this.ebOrder.ebServiceItems.forEach((el, index) => {
              el.rowStatus = 4;
              delete el.ebOrderId;
              delete el.ebServiceItemId;
              checkedArr.push(el.serviceCode + "/" + el.serviceName);
            });
            _this.ebServiceItemList = checkedArr;
            _this.ebServiceItemsBuffer = res.records.ebServiceItems;
            _this.ebOrderId = null;
            _this.$nextTick(() => {
              _this.$refs.bookingFormRef.clearValidate();
            });
            _this.ebPartys = {};
            _this.ebCtnRequests = _this.ebOrder.ebCtnRequests;
            _this.ebCtnRequests.forEach((item) => {
              item.ebOrderId = null;
              item.rowStatus = 4;
              item.ebCtnRequestId = null;
            });
            res.records.ebPartys.forEach((el) => {
              delete el.ebOrderId;
              delete el.ebPartyId;
              el.rowStatus = 4;
              _this.ebPartys["ebParty" + el.partyType] = el;
            });
            _this.ebParty = _this.ebPartys;
            _this.ebParams.ebPartys = _this.ebPartys;
            if (res.records.ebCargos.length > 1) {
              res.records.ebCargos.forEach((el) => {
                if (el.totalFlag === "M") {
                  el.rowStatus = 4;
                  delete el.ebCargoId;
                  delete el.ebOrderId;
                  _this.ebCargo.ebCargoM = el;
                } else {
                  el.rowStatus = 4;
                  delete el.ebCargoId;
                  delete el.ebOrderId;
                  _this.ebCargo.ebCargoD.push(el);
                }
              });
            }
            _this.ebParams.ebCargos = _this.ebCargo;
            _this.ebOrder.custBizNo = null;
            _this.ebOrder.ebOrderStatus = "NEW";
            _this.ebOrder.mblNo = null;
            _this.ebOrder.carrierName = null;
            _this.ebOrder.carrierId = null;
            _this.ebOrder.agreementNo = null;
            _this.ebOrder.nameAccount = null;
            _this.ebOrder.carrierSales = null;
            _this.ebOrder.settleOfficeName = null;
            _this.ebOrder.settleOffice = null;
            _this.ebOrder.csName = null;
            _this.ebOrder.csEmail = null;
            _this.ebOrder.csTel = null;
            _this.ebOrder.mobile = null;
            _this.ebOrder.csId = null;
            _this.ebOrder.vesselNameEn = null;
            _this.ebOrder.vesselId = null;
            _this.ebOrder.voyage = null;
            _this.ebOrder.etd = null;
            _this.ebOrder.terminalName = null;
            _this.ebOrder.terminalId = null;
            _this.ebOrder.realVesselNameEn = null;
            _this.ebOrder.realVoyage = null;
            _this.ebOrder.realVesselId = null;
            _this.ebOrder.realEtd = null;
            _this.ebOrder.terminalTime = null;
            _this.ebOrder.bargeVesselName = null;
            _this.ebOrder.bargeVesselId = null;
            _this.ebOrder.bargeVoyage = null;
            _this.ebOrder.bargeEtd = null;
            _this.ebOrder.bargeTerminalName = null;
            _this.ebOrder.bargeTerminalId = null;
            _this.ebOrder.ebCtnRequests = [];
            _this.ebOrder.ebCtns = [];
            _this.ebCtnRequestDetails = [];
            _this.ebCtnRequests = [];
            _this.ebOrder.bookingFeedBack = null;
            _this.ebOrder.jsonInfo = null;
            _this.ebOrder.orderNo = null;
            _this.ebOrder.fullOrderNo = null;
            _this.ebOrder.mfOrderId = null;
            _this.ebOrder.goOrderId = null;
            _this.ebOrder.shipAgencyName = null;
            _this.ebOrder.refuseReason = null;
            _this.ebOrder.ebOrderId = null;
            _this.ebOrder.rowStatus = 4;
          }
        }
      });
    },
    querySpOrderStatus(id) {
      let self = this;
      let data = {
        stageCode: "BK",
        goOrderId: id,
      };
      querySpOrderStatus(data)
          .then((res) => {
            if (res.success) {
              console.log(res);
              let newAxisStatusList = self.axisStatusList;
              res.records.node.forEach((item, index) => {
                newAxisStatusList[index]["index"] = item["index"];
                newAxisStatusList[index]["text"] = item["text"];
              });
              self.axisStatusList = newAxisStatusList;
            } else {
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    changeBizType(value, selectedRows) {
      this.ebOrder.bizTypeCode = selectedRows.codeValue;
    },
    //业务类型数据服务    哪个控件
    associate_queryMethod_bizTypeName({ keyword, pageSize, currentPage }) {
      let self = this;

      let whereParams = "";

      if (keyword === "") {
        whereParams = mdCodeDict.codeType
            .eq$("EB_MD_BUSSINESS_TYPE")
            .and(mdCodeDict.isActive.eq$(1))
            .and(mdCodeDict.isDeleted.eq$(0));
      } else {
        whereParams = mdCodeDict.codeValue
            .like$("%" + keyword + "%")
            .or(mdCodeDict.displayValueCn.like$("%" + keyword + "%"))
            .and(mdCodeDict.isActive.eq$(1))
            .and(mdCodeDict.isDeleted.eq$(0))
            .and(mdCodeDict.codeType.eq$("EB_MD_BUSSINESS_TYPE"));
      }
      let params = {
        whereObj: whereParams,
        page: currentPage,
        limit: pageSize,
      };
      return new Promise((resolve) => {
        mdCodeDict
            .queryMdCodeDict(params)
            .then((res) => {
              if (res.success) {
                resolve({
                  records: res.data.data,
                  total: res.data.totalRecord,
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
      });
    },
    // 签单方式
    changeIssueMode(val) {
      console.log("val", val);
      // 正本 O 01 电放 T 02 SWB: S 03
      if (val === "O") {
        this.ebOrder.noOfOriginal = "3";
        this.ebOrder.noOfCopy = "0";
      } else if (val === "T") {
        this.ebOrder.noOfOriginal = "0";
        this.ebOrder.noOfCopy = "0";
      } else if (val === "S") {
        this.ebOrder.noOfOriginal = "1";
        this.ebOrder.noOfCopy = "0";
      } else {
        this.ebOrder.noOfOriginal = "3";
        this.ebOrder.noOfCopy = "3";
      }
    },
    // 船公司联想控件数据源
    associate_queryMethod_carrier({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          custType4: "%SO%",
          isDeleted6: "0",
          isBlacklist: "0",
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "%SO%",
          isDeleted6: "0",
          isBlacklist: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_WEB_es",
        where:
            "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)\n",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryCarrierInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    //大船船名、航次、开航日期3个必输2
    twoNotNullInThree(rule, value, callback) {
      let self = this;
      let data = [
        self.ebOrder.vesselNameEn,
        self.ebOrder.voyage,
        self.ebOrder.etd,
      ];
      let i = 0;
      data.forEach((item) => {
        if (item !== "" && item !== null && item !== undefined) {
          i = i + 1;
        }
      });
      if (i < 2) {
        callback(new Error("船名/航次/开航日期必输2个"));
      }
      callback();
    },
    //驳船船名、航次、开航日期3个必输2
    twoNotNullInThreeBarge(rule, value, callback) {
      let self = this;
      console.log("self.ebOrder.bargeVesselName", self.ebOrder.bargeVesselName);
      let data = [
        self.ebOrder.bargeVesselName,
        self.ebOrder.bargeVoyage,
        self.ebOrder.bargeEtd,
      ];
      let i = 0;
      data.forEach((item) => {
        if (item !== "" && item !== null && item !== undefined) {
          i = i + 1;
        }
      });
      if (i < 2) {
        callback(new Error("驳船船名/航次/开航日期必输2个"));
      }
      callback();
    },
    carrierNameChange(value, selectedRows) {
      console.log(selectedRows)
      this.ebOrder.carrierId = selectedRows.csCustId;
      this.ebOrder.carrierName = selectedRows.custAlias;
    },
    //初始化界面根据ebOrderId获取界面数据
    getBookingDataByEbOrderIdAndFlag(ebOrderId, flag) {
      let params = {
        ebOrderId: ebOrderId,
        flag: flag,
      };
      let self = this;
      getBookingVO(params).then((res) => {
        console.log("getBookingVO:", res);
        if (res.success) {
          let data = res.data;
          //货物信息
          let ebCargoMap = eval("(" + JSON.stringify(data.ebCargoMap) + ")");
          self.ebCargo.ebCargoM = ebCargoMap.ebCargoM[0];
          self.ebCargo.ebCargoD = ebCargoMap.ebCargoD;
          //预配箱
          self.ebCtnRequests = data.ebCtnRequests;
          //预配箱明细
          self.ebCtnRequestDetails = data.ebCtnRequestDetails;
          //服务项
          self.ebServiceItems = data.ebServiceItems;
          self.ebServiceItems.forEach((item) => {
            let label = item.serviceCode + "/" + item.serviceName;
            self.ebServiceItemList.push(label);
          });
          console.log("ebServiceItemList:", self.ebServiceItemList);
          //收发通信息
          let ebPartyMap = eval("(" + JSON.stringify(data.ebPartyMap) + ")");
          self.ebParty = {
            ebPartySH: ebPartyMap.SH,
            ebPartyCN: ebPartyMap.CN,
            ebPartyNT: ebPartyMap.NT,
            ebPartyRSH: ebPartyMap.RSH,
            ebPartyRCN: ebPartyMap.RCN,
            ebPartyRNT: ebPartyMap.RNT,
          };
        }
      });
    },
    //获取数据字典
    getSelectList() {
      let self = this;
      queryDictRows(
          "MD_CODE_DICT$EB_PAYMENTMODE,MD_CODE_DICT$TRANSPORT_TERM,MD_CODE_DICT$ISSUE_TYPE,MD_CODE_DICT$MD_BK_NO_OF_BILL,CS_AGREEMENT_TYPE$ARG_TYPE,MD_CODE_DICT$EB_MD_CODE_SERVICE_REQUEST,MD_CODE_DICT$FREE_CTN_STATUS,MD_CODE_DICT$FREE_APP_STATUS"
      ).then((res) => {
        /*name:value value:key*/
        console.log("queryDictRows:", res);
        //付款方式
        self.mblPaymentTypeList = res.MD_CODE_DICT$EB_PAYMENTMODE;
        //运输条款
        self.mblTransportTermList = res.MD_CODE_DICT$TRANSPORT_TERM;
        //签单方式
        self.issueModeList = res.MD_CODE_DICT$ISSUE_TYPE;
        //正本份数、副本份数
        self.noOfOriginalList = res.MD_CODE_DICT$MD_BK_NO_OF_BILL;
        //批复状态
        self.approvalStatusList = res.MD_CODE_DICT$FREE_APP_STATUS;
        // 状态
        self.freeStatus = res.MD_CODE_DICT$FREE_CTN_STATUS;
        //所有服务项
        self.allEbServiceItems = res.MD_CODE_DICT$EB_MD_CODE_SERVICE_REQUEST;
        //协议类型-船公司扩展信息
        //目的地属性-船公司扩展信息
        //目的地运输方式-船公司扩展信息
      });
    },
    // 收货地/装货港/中转港/卸货港/交货地联想控件数据源
    associate_queryMethod_po({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          portType4: ["OP", "IP"],
          isDeleted5: "0",
          isActive: "1",
        };
      } else {
        params = {
          portNameEn0: "%" + keyword + "%",
          portNameCn1: "%" + keyword + "%",
          countryCode2: "%" + keyword + "%",
          portCode3: "%" + keyword + "%",
          portType4: ["OP", "IP"],
          isDeleted5: "0",
          isActive: "1",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdPort.portNameEn"],
        mainModelName: "CTS_ILPMdPort",
        tag: "CTS_ILP_es",
        where:
            "(((((CTS_ILPMdPort.portNameEn LIKE :portNameEn0 OR CTS_ILPMdPort.portNameCn LIKE :portNameCn1) OR CTS_ILPMdPort.countryCode LIKE :countryCode2) OR CTS_ILPMdPort.portCode LIKE :portCode3) AND CTS_ILPMdPort.portType IN( :portType4)) AND CTS_ILPMdPort.isDeleted = :isDeleted5 AND CTS_ILPMdPort.isActive = :isActive)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdPort.mdPortId",
          "CTS_ILPMdPort.createOffice",
          "CTS_ILPMdPort.lastModifyOffice",
          "CTS_ILPMdPort.lastModifyOfficeName",
          "CTS_ILPMdPort.lastModifierId",
          "CTS_ILPMdPort.areaCode",
          "CTS_ILPMdPort.lineNameCn",
          "CTS_ILPMdPort.portNameEn",
          "CTS_ILPMdPort.principalGroupCode",
          "CTS_ILPMdPort.customsCode",
          "CTS_ILPMdPort.isActive",
          "CTS_ILPMdPort.createOfficeName",
          "CTS_ILPMdPort.creatorName",
          "CTS_ILPMdPort.lastModifierName",
          "CTS_ILPMdPort.appCode",
          "CTS_ILPMdPort.longitude",
          "CTS_ILPMdPort.creatorId",
          "CTS_ILPMdPort.recordVersion",
          "CTS_ILPMdPort.lastModifyTime",
          "CTS_ILPMdPort.portNameCn",
          "CTS_ILPMdPort.portCode",
          "CTS_ILPMdPort.createTime",
          "CTS_ILPMdPort.isDeleted",
          "CTS_ILPMdPort.iataCode",
          "CTS_ILPMdPort.latitude",
          "CTS_ILPMdPort.lineId",
          "CTS_ILPMdPort.countryName",
          "CTS_ILPMdPort.countryCode",
          "CTS_ILPMdPort.portType",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPoInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 华贸分公司联想控件数据源
    associate_queryMethod_csOffice({ keyword, pageSize, currentPage }) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let params = {
        page: self.pageConfig.currentPage,
        limit: self.pageConfig.pageSize,
        csCustId: userInfo.custId,
      };
      if (keyword !== "") {
        params.corpNameCn = keyword;
      }
      return new Promise((resolve) => {
        sysCorpCust.getsysCorpCustCsOffice(params).then((res) => {
          /*if(res.data.totalRecord === 1){
            self.ebOrder.settleOfficeName = res.data.data[0].corpNameCn;
          }*/
          resolve({
            records: res.data.data,
            total: res.data.length,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 华贸客服联想控件数据源
    associate_queryMethod_csUser({ keyword, pageSize, currentPage }) {
      let params = {
        currentPage: currentPage,
        pageSize: pageSize
      };
      return new Promise(resolve => {
        querySales(params).then(res => {
          resolve({
            records: res.records,
            total: res.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 箱型尺寸联想控件数据源
    associate_queryMethod_ctnSizeType({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
          isActive: "1",
        };
      } else {
        params = {
          isDeleted0: "%" + keyword + "%",
          containerType1: "%" + keyword + "%",
          isDeleted2: "0",
          isActive: "1",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdContainerType.containerType"],
        mainModelName: "CTS_ILPMdContainerType",
        tag: "CTS_ILP_es",
        where:
            "((CTS_ILPMdContainerType.isDeleted LIKE :isDeleted0 OR CTS_ILPMdContainerType.containerType LIKE :containerType1) AND CTS_ILPMdContainerType.isDeleted = :isDeleted2 AND CTS_ILPMdContainerType.isActive = :isActive)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdContainerType.mdContainerTypeId",
          "CTS_ILPMdContainerType.containerTypeName",
          "CTS_ILPMdContainerType.recordVersion",
          "CTS_ILPMdContainerType.ctnHeight",
          "CTS_ILPMdContainerType.principalGroupCode",
          "CTS_ILPMdContainerType.lastModifierId",
          "CTS_ILPMdContainerType.ctnWeight",
          "CTS_ILPMdContainerType.lastModifyOffice",
          "CTS_ILPMdContainerType.creatorName",
          "CTS_ILPMdContainerType.createOffice",
          "CTS_ILPMdContainerType.teu",
          "CTS_ILPMdContainerType.isActive",
          "CTS_ILPMdContainerType.creatorId",
          "CTS_ILPMdContainerType.createTime",
          "CTS_ILPMdContainerType.lastModifyOfficeName",
          "CTS_ILPMdContainerType.ctnWidth",
          "CTS_ILPMdContainerType.containerSize",
          "CTS_ILPMdContainerType.lastModifyTime",
          "CTS_ILPMdContainerType.ctnDescriptionEn",
          "CTS_ILPMdContainerType.ctnDescriptionCn",
          "CTS_ILPMdContainerType.maxWeight",
          "CTS_ILPMdContainerType.containerType",
          "CTS_ILPMdContainerType.ctnLength",
          "CTS_ILPMdContainerType.lastModifierName",
          "CTS_ILPMdContainerType.isDeleted",
          "CTS_ILPMdContainerType.appCode",
          "CTS_ILPMdContainerType.maxMeas",
          "CTS_ILPMdContainerType.reamrk",
          "CTS_ILPMdContainerType.createOfficeName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryCtnSizeInfo(data).then((res) => {
          console.log("queryCtnSizeInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 箱公司联想控件数据源
    associate_queryMethod_ctnCompany({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted6: "0",
          custType4: "%CO%",
          // isBlacklist6: "0",
          isActive: "1",
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
          isDeleted6: "0",
          custType4: "%CO%",
          // isBlacklist6: "0",
          isActive: "1",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_WEB_es",
        where:
            "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryCtnCompanyInfo(data).then((res) => {
          console.log("queryCtnCompanyInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 船名联想控件数据源
    associate_queryMethod_vessel({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.vesselName"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
            "(((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 航次联想控件数据源
    associate_queryMethod_voyage({ keyword, pageSize, currentPage }) {
      let params = {};
      let whereObj = null;
      if (keyword === "") {
        params = {
          isDeleted3: "0",
        };
      } else {
        params = {
          isDeleted3: "0",
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
          voyageCode2: "%" + keyword + "%",
        };
      }

      if (this.ebOrder.vesselNameEn) {
        params.vesselId = this.ebOrder.vesselId;
        whereObj =
            "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3 AND CTS_ILPMdVoyagePlan.vesselId = :vesselId)";
      } else {
        whereObj =
            "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)";
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        mainModelName: "CTS_ILPMdVoyagePlan",
        sorting: ["CTS_ILPMdVoyagePlan.voyage"],
        tag: "CTS_ILP_es",
        where: whereObj,
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("queryVoyageInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 驳船航次联想控件数据源
    associate_queryMethod_voyage2({ keyword, pageSize, currentPage }) {
      let params = {};
      let whereObj = null;
      if (keyword === "") {
        params = {
          isDeleted3: "0",
        };
      } else {
        params = {
          isDeleted3: "0",
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
          voyageCode2: "%" + keyword + "%",
        };
      }
      if (this.ebOrder.bargeVesselName) {
        params.vesselId = this.ebOrder.bargeVesselId;
        whereObj =
            "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3 AND CTS_ILPMdVoyagePlan.vesselId = :vesselId)";
      } else {
        whereObj =
            "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)";
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        mainModelName: "CTS_ILPMdVoyagePlan",
        sorting: ["CTS_ILPMdVoyagePlan.voyage"],
        tag: "CTS_ILP_es",
        where: whereObj,
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("queryVoyageInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 作业码头联想控件数据源     IS_ACTIVE = 1 AND IS_DELETED = 0 AND FACILITY_TYPE LIKE '%MT%'
    associate_queryMethod_terminal({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          facilityType: "%MT%",
          isDeleted3: "0",
          isActive: "1",
        };
      } else {
        params = {
          facilityType: "%MT%",
          isDeleted3: "0",
          isActive: "1",
          shortName: "%" + keyword + "%",
          mnemonicCode: "%" + keyword + "%",
          facilityNameCn: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdFacility.facilityType"],
        mainModelName: "CTS_ILPMdFacility",
        tag: "CTS_ILP_es",
        where:
            "((((((((CTS_ILPMdFacility.shortName LIKE :shortName) OR CTS_ILPMdFacility.shortName LIKE :shortName)) OR CTS_ILPMdFacility.mnemonicCode LIKE :mnemonicCode) OR CTS_ILPMdFacility.facilityNameCn LIKE :facilityNameCn) AND CTS_ILPMdFacility.isDeleted = :isDeleted3) AND CTS_ILPMdFacility.isActive = :isActive)AND CTS_ILPMdFacility.facilityType like :facilityType)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        enableCascade: true,
        fields: [
          "CTS_ILPMdFacility.facilityNameCn",
          "CTS_ILPMdFacility.shortName",
          "CTS_ILPMdFacility.mdFacilityId",
          "CTS_ILPMdFacility.mnemonicCode",
        ],
      };

      return new Promise((resolve) => {
        querybizTypeName(data)
            .then((res) => {
              if (res.success) {
                resolve({
                  records: res.data.data,
                  total: res.data.totalRecord,
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
      });
    },
    // 拼箱checkBox改变事件
    onChangeIsLcl() {
      let self = this;
      if (self.ebOrder.isLcl === 1) {
        // self.ebOrder.bizTypeCode = "MFEL";
        // self.ebOrder.bizTypeName = "海运拼箱出口分单";
        self.ebOrder.bizBigTypeCode = "MFE";
        self.ebOrder.bizBigTypeName = "海运集装箱出口";
      } else if (self.ebOrder.isLcl === 0) {
        // self.ebOrder.bizTypeCode = "MFEF";
        // self.ebOrder.bizTypeName = "海运整箱出口";
        self.ebOrder.bizBigTypeCode = "MFE";
        self.ebOrder.bizBigTypeName = "海运集装箱出口";
      }
    },
    // 签单地点
    changePlaceOfIssueName(value, selectedRows) {
      this.ebOrder.placeOfIssueName = selectedRows.portNameEn;
      this.ebOrder.placeOfIssueId = selectedRows.mdPortId;
    },
    // 华贸分公司
    changeCsOffice(value, selectedRows) {
      this.ebOrder.settleOfficeName = selectedRows.corpNameCn;
      this.ebOrder.settleOffice = selectedRows.sysCorpId;
    },
    //华贸客服联想控件改变事件
    onChangeCsOffice(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.csName = selectedRows.salesNameCn;
      this.ebOrder.csId = selectedRows.salesId;
      this.ebOrder.csEmail = selectedRows.email;
      this.ebOrder.csTel = selectedRows.tel;
      this.ebOrder.mobile = selectedRows.mobileNo;
    },
    //大船船名联想控件修改事件
    onChangeVessel(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.vesselId = selectedRows.vesselId;
      this.ebOrder.vesselNameEn = selectedRows.vesselName;
      this.ebOrder.voyage = selectedRows.voyage;
    },
    // 大船航次联想控件修改事件
    onChangeVoyage(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.voyage = selectedRows.voyage;
    },
    //驳船船名联想控件修改事件
    onChangeBargeVessel(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.bargeVesselId = selectedRows.vesselId;
      this.ebOrder.bargeVesselName = selectedRows.vesselName;
      this.ebOrder.bargeVoyage = selectedRows.voyage;
    },
    //作业码头联想控件修改事件
    onChangeTerminal(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.terminalId = selectedRows.mdFacilityId;
      this.ebOrder.terminalName = selectedRows.shortName;
    },
    // 付款地点
    changeMblPaymentPlace(value, selectedRows) {
      this.ebOrder.mblPaymentPlace = selectedRows.portNameEn;
      this.ebOrder.mblPaymentPlaceId = selectedRows.mdPortId;
    },
    //驳船作业码头联想控件修改事件
    onChangeBargeTerminal(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.bargeTerminalId = selectedRows.mdFacilityId;
      this.ebOrder.bargeTerminalName = selectedRows.shortName;
    },
    //收货地联想控件修改事件
    onChangePor(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.porId = selectedRows.mdPortId;
      this.ebOrder.porCode = selectedRows.portCode;
      this.ebOrder.porName = selectedRows.portNameEn;
      this.$forceUpdate();
    },
    //装货港联想控件修改事件
    onChangePol(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.polId = selectedRows.mdPortId;
      this.ebOrder.polCode = selectedRows.portCode;
      this.ebOrder.polName = selectedRows.portNameEn;
      this.$forceUpdate();
    },
    //中转港联想控件修改事件
    onChangePot(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.potId = selectedRows.mdPortId;
      this.ebOrder.potCode = selectedRows.portCode;
      this.ebOrder.potName = selectedRows.portNameEn;
      this.$forceUpdate();
    },
    //卸货港联想控件修改事件
    onChangePod(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.podId = selectedRows.mdPortId;
      this.ebOrder.podCode = selectedRows.portCode;
      this.ebOrder.podName = selectedRows.portNameEn;
      this.$forceUpdate();
    },
    //交货地联想控件修改事件
    onChangePlaceOfDelivery(value, selectedRows) {
      console.log("selectedRows", "selectedRows");
      this.ebOrder.placeOfDeliveryId = selectedRows.mdPortId;
      this.ebOrder.placeOfDeliveryCode = selectedRows.portCode;
      this.ebOrder.placeOfDeliveryName = selectedRows.portNameEn;
      this.$forceUpdate();
    },
    //箱公司联想控件修改事件
    onChangeCtnCompany(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      // this.ebOrder.ctnCompanyId = selectedRows.csCustId;
      this.ebCtnRequests[this._index].ctnCompanyId = selectedRows.csCustId;
    },
    //服务项修改事件
    onChangeEbServiceItem(val) {
      console.log(val);
      console.log("ebServiceItemList", this.ebServiceItemList);
    },
    // 修改表格后事件
    afterChangeEbCtnRequest(change, source) {
      console.log("change", change);
      let self = this;
      if (change != null) {
        // change[0][0] 第几条数据 from 0  source[ change[0][0] ]
        // change[0][1] 字段名 eg：ediCodeName
        // change[0][2] 原值
        // change[0][3] 新值
        if (self.ebCtnRequests.length !== 0) {
          if (
              change[0][1] !== "$$checked" &&
              change[0][2] !== change[0][3] &&
              self.ebCtnRequests[change[0][0]].rowStatus !== 4
          ) {
            self.ebCtnRequests[change[0][0]].rowStatus = 16;
            console.log("修改行", this.ebCtnRequests[change[0][0]]);
          }
        }
      }
      // 汇总箱型箱量信息
      this.ebOrder.ctnNum = "";
      let ctnNumArr = [];
      if (this.ebCtnRequests.length > 0) {
        this.ebCtnRequests.forEach((el, i) => {
          if (el.ctnQuantity && el.ctnSizeType) {
            ctnNumArr.push(el.ctnSizeType + "*" + el.ctnQuantity);
          }
        });
      }
      ctnNumArr.forEach((el) => {
        this.ebOrder.ctnNum = this.ebOrder.ctnNum + "+" + el;
      });
      this.ebOrder.ctnNum = this.ebOrder.ctnNum.slice(1);
      this.$route.meta.verifyValue = false;
      this.$store.dispatch("tagsView/updateVisitedView", this.$route);
    },
    // 修改表格后事件
    afterChangeEbCtnRequestDetail(change, source) {
      console.log("change", change);
      let self = this;
      if (change != null) {
        // change[0][0] 第几条数据 from 0  source[ change[0][0] ]
        // change[0][1] 字段名 eg：ediCodeName
        // change[0][2] 原值
        // change[0][3] 新值
        if (
            change[0][1] !== "$$checked" &&
            change[0][2] !== change[0][3] &&
            this.ebCtnRequestDetails[change[0][0]].rowStatus !== 4
        ) {
          self.ebCtnRequestDetails[change[0][0]].rowStatus = 16;
          console.log("修改行", this.ebCtnRequestDetails[change[0][0]]);
        }
      }
      this.$route.meta.verifyValue = false;
      this.$store.dispatch("tagsView/updateVisitedView", this.$route);
    },
    // 新增行
    addNewRow() {
      let self = this;
      let newRow = [
        {
          rowStatus: 4, // 新增行状态值为4，修改行状态值为16
          isDeleted: 0,
          fclLclFlag: "FCL",
          isNor: 0,
          isSoc: 0,
        },
      ];
      self.ebCtnRequests = newRow.concat(self.ebCtnRequests);
      // 选中第一条高亮显示
      self.$refs.ebCtnRequestRef.hotInstance.addHookOnce(
          "afterLoadData",
          function () {
            self.$nextTick(function () {
              self.$refs.ebCtnRequestRef.hotInstance.selectCell(0, 1);
            });
          }
      );
    },
    compare(property) {
      return function (a, b) {
        var value1 = Number(a[property].substring(a[property].length - 16));
        var value2 = Number(b[property].substring(b[property].length - 16));
        return value1 - value2;
      };
    },
    //制作舱单
    makeManifest() {
      let self = this;
      if (this.ebOrder.orderStatus === "CRM") {
        self.getEbServiceItem(this.ebOrder.ebOrderId).then(res => {
          let isMakeManifest = res.find(item => item.serviceCode === 'FT')
          if (!isMakeManifest) return self.$coreMethods.message("warning", "没有舱单服务项，不允许制作舱单");
          self.$router.push({
            name: "manifestAdd",
            query: {
              ebOrderId: this.ebOrder.ebOrderId,
              isAddManiFest: false,
              mainfest: "makeManifest",
            },
          });
        })
      } else {
        self.$coreMethods.message("warning", "请选择状态为已接收的记录");
      }
    },
    //制作提单
    makeBLN() {
      let self = this;
      if (this.ebOrder.orderStatus === "CRM") {
        self.getEbServiceItem(this.ebOrder.ebOrderId).then(res => {
          let isMakeManifest = res.find(item => item.serviceCode === 'MBL')
          if (!isMakeManifest) return self.$coreMethods.message("warning", "没有MBL服务项，不允许制作提单");
          self.$router.push({
            name: "ladingbillEdit",
            params: {
              ebOrderId: this.ebOrder.ebOrderId,
              type: "edit",
            },
          });
        })
      } else {
        self.$coreMethods.message("warning", "请选择状态为已接收的记录");
      }
    },
    getEbServiceItem(id) {
      let data = {
        ebOrderId: id
      }
      return getEbServiceItem(data)
    },
    saveNew(submitType) {
      let self = this;
      if (self.ebServiceItemList.length <= 0) {
        return self.$coreMethods.message("error", "请先勾选服务项");
      }
      if (self.bookingFormRules.settleOfficeName) {
        self.bookingFormRules.settleOfficeName[0].required = false;
      }
      //ebParty表单校验
      self.$refs.ebPartyRef.ebPartyValidate(ebPartyValid => {
        self.$refs.ebCargoRef.ebCargoValidate(ebCargoValid => {
            //ebOrder校验
        self.$refs.bookingFormRef.validate((ebOrderValid) => {
          //ebCtnRequest表格校验
          self.$refs.ebCtnRequestRef.hotInstance.validateColumns(
              [1, 2],
              (ebCtnRequestValid) => {
                if (ebPartyValid && ebCargoValid && ebOrderValid && ebCtnRequestValid) {
                  self.ebOrder.urgentLevel = "N";
                  self.ebOrder.ebOrderStatus = "NEW";
                  let userInfo = JSON.parse(localStorage.getItem("userInfo"));
                  self.ebOrder.submitPersonId = userInfo.userId;
                  self.ebOrder.submitPerson = userInfo.userNameCn;
                  self.ebOrder.ebPartys = [];
                  for (let key in self.ebParams.ebPartys) {
                    self.ebOrder.ebPartys.push(self.ebParams.ebPartys[key]);
                  }
                  self.ebOrder.ebCtnRequests = self.ebCtnRequests;
                  if (self.ebCtnRequestDetails &&
                      self.ebCtnRequestDetails.length > 0) {
                    self.ebOrder.ebCtns = self.ebCtnRequestDetails.concat(
                        self.ebCtnRequestDetailDelete
                    );
                  }
                  self.ebOrder.ebCargos = [self.ebParams.ebCargos.ebCargoM];
                  self.ebOrder.ebCargoDetails = self.ebParams.ebCargos.ebCargoD;
                  let ebServiceItemsCopy = [];
                  let ebServiceItemListLike = [];
                  let ebServiceItemCopyList = [];
                  //服务项
                  if (!self.ebOrder.ebOrderId) {
                    self.ebOrder.ebServiceItems = [];
                    self.ebServiceItemList.forEach((el) => {
                      self.ebOrder.ebServiceItems.push({
                        serviceName: el.split("/")[1],
                        serviceCode: el.split("/")[0],
                        rowStatus: 4,
                      });
                    });
                  } else {
                    if (self.ebOrder.ebServiceItems &&
                        self.ebOrder.ebServiceItems.length > 0) {
                      //暂存服务项
                      ebServiceItemsCopy = JSON.parse(
                          JSON.stringify(self.ebOrder.ebServiceItems)
                      );
                      ebServiceItemsCopy.forEach((el) => {
                        ebServiceItemCopyList.push(
                            el.serviceCode + "/" + el.serviceName
                        );
                      });
                    }
                    //合并后的服务项
                    self.ebOrder.ebServiceItems = [];
                    let AllebServiceItemCopyList = [
                      ...new Set(
                          ebServiceItemCopyList.concat(self.ebServiceItemList)
                      ),
                    ];
                    let ebServiceItemListCopy = JSON.parse(
                        JSON.stringify(self.ebServiceItemList)
                    );
                    if (
                        self.ebServiceItemsBuffer &&
                        self.ebServiceItemsBuffer.length > 0
                    ) {
                      self.ebServiceItemsBuffer.forEach((item) => {
                        let isDel = self.ebServiceItemList.findIndex(
                            (newItem) => {
                              return item.serviceCode === newItem.split("/")[0];
                            }
                        );
                        if (isDel === -1) item.rowStatus = 8;
                        self.ebOrder.ebServiceItems.push(item);
                      });
                    }
                    if (self.ebServiceItemList &&
                        self.ebServiceItemList.length > 0) {
                      self.ebServiceItemList.forEach((item) => {
                        let isAdd = self.ebServiceItemsBuffer.findIndex(
                            (oldItem) => {
                              return oldItem.serviceCode === item.split("/")[0];
                            }
                        );
                        if (isAdd === -1) {
                          let addItem = {
                            serviceName: item.split("/")[1],
                            serviceCode: item.split("/")[0],
                            rowStatus: 4,
                          };
                          self.ebOrder.ebServiceItems.push(addItem);
                        }
                      });
                    }
                  }
                  /*if (self.ebOrderType === "copy") {
                    self.ebOrder.rowStatus = 4;
                    self.ebOrder.ebOrderId = null;
                    self.ebOrder.ebPartys.forEach((item) => {
                      item.rowStatus = 4;
                    });
                    self.ebOrder.ebServiceItems.forEach((item) => {
                      item.rowStatus = 4;
                    });
                    self.ebOrder.ebCtns.forEach((item) => {
                      item.rowStatus = 4;
                    });
                  }*/
                  self.ebOrder.jsonInfo = JSON.stringify(self.bookingForm)
                  if (self.ebCtnRequests.length <= 0) {
                    self.$coreMethods.message("error", "请维护预配箱信息");
                  } else {
                    if (submitType === 2) {
                      publicSave({
                        ebOrderDTO: self.ebOrder,
                        dataType: "ORDER",
                      }).then((res) => {
                        if (res.success) {
                          self.getOrder(res.records.ebOrderId, "edit");
                          self.$coreMethods.message("success", "保存成功！");
                          let params = self.$refs.ebOrderTableRef.getSelections();
                          sessionStorage.setItem("ebOrderParams", JSON.stringify(params));
                          sessionStorage.setItem("ebOrderType", "Add");
                          self.$router.push({
                            path: "/booking/edit",
                            params: {
                              ebOrderId: params[0].ebOrderId,
                              type: "Add",
                            },
                          });
                        } else {
                          self.$coreMethods.message("error", "保存失败！");
                        }
                      });
                    } else if (submitType === 3) {
                      saveAndSub({
                        ebOrderDTO: self.ebOrder,
                        dataType: "ORDER",
                        type: "web",
                      }).then((res) => {
                        if (res.success) {
                          self.ebOrder = res.records;
                          self.$coreMethods.message("success", "提交成功！");
                          self.$store
                              .dispatch("tagsView/delView", self.$route)
                              .then(() => {
                                self.$nextTick(() => {
                                  self.$router.push({ name: "bookingManage" });
                                });
                              });
                        } else {
                          self.submitVisible = false;
                          self.$coreMethods.message("error", "提交失败！");
                        }
                      });
                    }
                  }
                } else {
                   if(!ebPartyValid) {
                     self.$refs.ebPartyRef.validateAutoFocus();
                   } else if(!ebOrderValid) {
                    self.validateAutoFocus();
                  } else if(!ebCargoValid) {
                    self.$refs.ebCargoRef.validateAutoFocus();
                  }

                }
              }
          );
        });
          });
      });


    },
    //提交
    submit() {
      let self = this;
      if (self.ebServiceItemList.length <= 0) {
        return self.$coreMethods.message("error", "请先勾选服务项");
      }
      if (self.bookingFormRules.settleOfficeName) {
        self.bookingFormRules.settleOfficeName[0].required = true;
      }
      //ebParty表单校验
      let ebPartyValid = self.$refs.ebPartyRef.ebPartyValidate();
      //ebCargo表单校验
      let ebCargoValid = self.$refs.ebCargoRef.ebCargoValidate();
      let isFlag = self.$refs.bookingFormRef.validate();
      console.log(isFlag);
      self.ebOrder.urgentLevel = "N";
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      self.ebOrder.submitPersonId = userInfo.userId;
      self.ebOrder.submitPerson = userInfo.userNameCn;
      self.ebOrder.ebPartys = [];
      for (let key in self.ebParams.ebPartys) {
        self.ebOrder.ebPartys.push(self.ebParams.ebPartys[key]);
      }
      self.ebOrder.ebCtnRequests = self.ebCtnRequests;
      if (
          self.ebCtnRequestDetails &&
          self.ebCtnRequestDetails.length > 0 &&
          self.ebCtnRequestDetailDelete.length > 0
      ) {
        self.ebOrder.ebCtns = self.ebCtnRequestDetails.concat(
            self.ebCtnRequestDetailDelete
        );
      }
      self.ebOrder.ebCargos = [self.ebParams.ebCargos.ebCargoM];
      self.ebOrder.ebCargoDetails = self.ebParams.ebCargos.ebCargoD;
      // self.ebOrder.rowStatus = 4;
      //ebOrder校验
      self.$refs.bookingFormRef.validate((ebOrderValid) => {
        //ebCtnRequest表格校验
        self.$refs.ebCtnRequestRef.hotInstance.validateColumns(
            [1, 2],
            (ebCtnRequestValid) => {
              if (
                  ebPartyValid &&
                  ebCargoValid &&
                  ebOrderValid &&
                  ebCtnRequestValid
              ) {
                // if (self.ebOrder.orderStatus === 'NEW' || self.ebOrder.orderStatus === 'REF') {
                let ebServiceItemsCopy = [];
                let ebServiceItemListLike = [];
                let ebServiceItemCopyList = [];
                if (!self.ebOrder.ebOrderId) {
                  self.ebOrder.ebServiceItems = [];
                  self.ebServiceItemList.forEach((el) => {
                    self.ebOrder.ebServiceItems.push({
                      serviceName: el.split("/")[1],
                      serviceCode: el.split("/")[0],
                      rowStatus: 4,
                    });
                  });
                } else {
                  if (
                      self.ebOrder.ebServiceItems &&
                      self.ebOrder.ebServiceItems.length > 0
                  ) {
                    //暂存服务项
                    ebServiceItemsCopy = JSON.parse(
                        JSON.stringify(self.ebOrder.ebServiceItems)
                    );

                    ebServiceItemsCopy.forEach((el) => {
                      ebServiceItemCopyList.push(
                          el.serviceCode + "/" + el.serviceName
                      );
                    });
                  }
                  // let ebServiceItemListCopy = JSON.parse(JSON.stringify(self.ebServiceItemList))
                  //合并后的服务项
                  self.ebOrder.ebServiceItems = [];
                  let AllebServiceItemCopyList = [
                    ...new Set(
                        ebServiceItemCopyList.concat(self.ebServiceItemList)
                    ),
                  ];
                  let ebServiceItemListCopy = JSON.parse(
                      JSON.stringify(self.ebServiceItemList)
                  );

                  if (
                      self.ebServiceItemsBuffer &&
                      self.ebServiceItemsBuffer.length > 0
                  ) {
                    self.ebServiceItemsBuffer.forEach((item) => {
                      let isDel = self.ebServiceItemList.findIndex((newItem) => {
                        return item.serviceCode === newItem.split("/")[0];
                      });
                      if (isDel === -1) item.rowStatus = 8;
                      self.ebOrder.ebServiceItems.push(item);
                    });
                  }
                  if (
                      self.ebServiceItemList &&
                      self.ebServiceItemList.length > 0
                  ) {
                    self.ebServiceItemList.forEach((item) => {
                      let isAdd = self.ebServiceItemsBuffer.findIndex(
                          (oldItem) => {
                            return oldItem.serviceCode === item.split("/")[0];
                          }
                      );
                      if (isAdd === -1) {
                        let addItem = {
                          serviceName: item.split("/")[1],
                          serviceCode: item.split("/")[0],
                          rowStatus: 4,
                        };
                        self.ebOrder.ebServiceItems.push(addItem);
                      }
                    });
                  }
                }
                self.ebCargo.ebCargoD = [];
                if (self.ebOrder.orderStatus === "UPDSUB") {
                  self.ebOrder.orderStatus = "UPDSUB";
                } else {
                  // self.ebOrder.type = "SUB";
                }
                self.ebOrder.jsonInfo = JSON.stringify(self.bookingForm)
                if (self.ebOrder.ebOrderId) {
                  publicSubmit({
                    ebOrderDTO: self.ebOrder,
                    dataType: "ORDER",
                    type: "web",
                  }).then((res) => {
                    if (res.success) {
                      self.submitVisible = true;
                      self.$coreMethods.message("success", "提交成功！");
                      //关闭并跳转
                      self.$store
                          .dispatch("tagsView/delView", self.$route)
                          .then(() => {
                            self.$nextTick(() => {
                              self.$router.push({ name: "bookingManage" });
                            });
                          });
                    } else {
                      self.submitVisible = false;
                      self.$coreMethods.message("error", "提交失败！");
                    }
                  });
                } else {
                  saveAndSub({
                    ebOrderDTO: self.ebOrder,
                    dataType: "ORDER",
                    type: "web",
                  }).then((res) => {
                    if (res.success) {
                      self.ebOrder = res.records;
                      self.$coreMethods.message("success", "提交成功！");
                      self.$store
                          .dispatch("tagsView/delView", self.$route)
                          .then(() => {
                            self.$nextTick(() => {
                              self.$router.push({ name: "bookingManage" });
                            });
                          });
                    } else {
                      self.submitVisible = false;
                      self.$coreMethods.message("error", "提交失败！");
                    }
                  });
                }
              }
            }
        );
      });
    },
    // 场内场外求和
    sumFreeDaysChange() {
      if (this.ebOrder.freeStorage && this.ebOrder.freeOfDetention) {
        this.ebOrder.freeStorage = parseInt(this.ebOrder.freeStorage);
        this.ebOrder.freeOfDetention = parseInt(this.ebOrder.freeOfDetention);
        this.ebOrder.freeDays =
            this.ebOrder.freeStorage + this.ebOrder.freeOfDetention;
        this.$forceUpdate();
      } else if (this.ebOrder.freeStorage) {
        this.ebOrder.freeStorage = parseInt(this.ebOrder.freeStorage);
        this.ebOrder.freeDays = this.ebOrder.freeStorage;
      } else if (this.ebOrder.freeOfDetention) {
        this.ebOrder.freeOfDetention = parseInt(this.ebOrder.freeOfDetention);
        this.ebOrder.freeDays = this.ebOrder.freeOfDetention;
      }
    },
    //取消提交
    //增加【撤销提交】按钮，点击按钮，更新EI_ORDER表的IS_ACTIVE = 0
    cancelSubmit() {
      let self = this;
      self.$coreMethods.confirm(
          function () {
            let orderStatus = "";
            if (self.ebOrder.orderStatus === "SUB") {
              orderStatus = "NEW";
            } else if (self.ebOrder.orderStatus === "UPDSUB") {
              orderStatus = "CRM";
            }
            revokeSub({
              ebOrderIds: [self.ebOrder.ebOrderId],
              orderStatus: orderStatus,
              dataType: "ORDER"
            }).then((res) => {
              if (res.success) {
                self.ebOrder.orderStatus = orderStatus;
                self.getOrder(self.ebOrder.ebOrderId, "edit");
                self.$coreMethods.message("success", "撤销提交成功");
                self.submitVisible = true;
              } else {
                self.$coreMethods.message("error", "撤销提交失败");
              }
            });
          },
          function () {
          },
          false,
          "是否执行撤销操作？"
      );
    },
    pageInit() {
      let self = this;
      if (
          self.ebOrder.ebOrderId !== undefined &&
          self.ebOrder.ebOrderId !== "" &&
          self.ebOrder.ebOrderId !== null
      ) {
        getOrderdata({ ebOrderId: self.ebOrder.ebOrderId }).then((res) => {
          if (res.success) {
            self.ebCargo.ebCargoD = [];
            self.ebOrder = res.records;
            self.ebOrder.noOfOriginal = res.records.noOfOriginal.toString();
            self.ebOrder.noOfCopy = res.records.noOfCopy.toString();
            self.ebCtnRequests = res.records.ebCtnRequests;
            self.ebCtnRequestDetails = res.records.ebCtns;
            let checkedArr = [];
            if (
                self.ebOrder.ebServiceItems &&
                self.ebOrder.ebServiceItems.length > 0
            ) {
              self.ebOrder.ebServiceItems.forEach((el, index) => {
                checkedArr.push(el.serviceCode + "/" + el.serviceName);
              });
            }
            self.ebParty = {};
            if (res.records.ebPartys.length > 0) {
              res.records.ebPartys.forEach((el) => {
                self.ebParty["ebParty" + el.partyType] = el;
              });
            }
            // self.ebParty = self.ebPartys
            self.ebParams.ebPartys = self.ebParty;
            if (res.records.ebCargos.length > 1) {
              res.records.ebCargos.forEach((el) => {
                if (el.totalFlag === "M") {
                  self.ebCargo.ebCargoM = el;
                } else {
                  self.ebCargo.ebCargoD.push(el);
                }
              });
            }
            self.ebServiceItemList = checkedArr;
            self.ebServiceItemsBuffer = res.records.ebServiceItems;
            if (self.ebOrderType === "copy") {
              self.ebOrderType = null;
            }
          }
        });
      }
    },
    //存为模板
    saveTemplate: async function () {
      let self = this;
      //ebParty表单校验
      let ebPartyValid = await self.$refs.ebPartyRef.ebPartyValidate();
      //ebCargo表单校验
      let ebCargoValid = await self.$refs.ebCargoRef.ebCargoValidate();
      //ebOrder校验
      self.$refs.ebOrder.validate(async (ebOrderValid) => {
        //ebCtnRequest表格校验
        self.$refs.ebCtnRequestRef.hotInstance.validateColumns(
            [1, 2],
            (ebCtnRequestValid) => {
              //if (ebPartyValid && ebCargoValid && ebOrderValid && ebCtnRequestValid) {
              let bookingDTO = self.bookingVOToDTO();
              saveBookingDTO(bookingDTO).then((res) => {
                /**待办：需要把保存后的数据回显到界面或是把ebOrderId传递出来 **/
                if (res.success) {
                  //获取保存成功之后的数据
                  self.getBookingDataByEbOrderIdAndFlag(res.data, 1);
                  let ebCargos = [];
                  self.ebCargo.ebCargoD.forEach((item) => {
                    ebCargos.push(item);
                  });
                  ebCargos.push(self.ebCargo.ebCargoM);
                  let ebParties = [];
                  for (let key in self.ebParty) {
                    ebParties.push(self.ebParty[key]);
                  }
                  self.allBookingDTO = {
                    ebOrder: self.ebOrder,
                    ebCtnRequests: self.ebCtnRequests,
                    ebCtnRequestDetails: self.ebCtnRequestDetails,
                    ebServiceItems: self.ebServiceItems,
                    ebParties: ebParties,
                    ebCargos: ebCargos,
                  };
                  self.saveTemplateVisible = !self.saveTemplateVisible;
                } else {
                  self.$coreMethods.message("error", "保存失败！");
                }
              });
              // }
            }
        );
      });
    },
    //改配历史
    changeHistory() {
      this.changeHistoryVisible = !this.changeHistoryVisible;
    },
    //批量删除预配箱信息
    batchDeleteEbCtnRequest() {
      // let self = this;
      // let params = self.$refs.ebCtnRequestRef.getSelections();
      // if (params.length !== 0) {
      //   // 删除操作
      //   params.forEach((item) => {
      //     let index = self.ebCtnRequests.indexOf(item);
      //     self.ebCtnRequests.splice(index, 1);
      //     item.rowStatus = 8;
      //     self.ebCtnRequestDelete.push(item);
      //   });
      //   // deleteEbCargo({"ebCtnRequestIds": ebCtnRequestIds}).then(res => {

      //   // })
      // } else {
      //   self.$coreMethods.message("warning", "请勾选你要删除的数据");
      // }
      let self = this;
      let delFlag = true;
      let deleteParams = [];
      let params = self.$refs.ebCtnRequestRef.getSelections();
      // 判断是否选中行都为新增行
      params.forEach((item) => {
        if (item.rowStatus !== 4) {
          deleteParams.push(item);
          delFlag = false;
        }
      });
      // 如果删除行都为新增行则不进行数据库操作
      if (params.length !== 0) {
        self.$coreMethods.confirm(
            function () {
              if (delFlag) {
                // 删除操作
                params.forEach((item) => {
                  let index = self.ebCtnRequests.indexOf(item);
                  self.ebCtnRequests.splice(index, 1);
                  item.rowStatus = 8;
                });
                self.synchronizeToDetail(true);
              } else {
                let ebCtnRequestIds = [];
                deleteParams.forEach((el) => {
                  ebCtnRequestIds.push(el.ebCtnRequestId);
                });

                deleteEbCtnRequest({ ebCtnRequestIds: ebCtnRequestIds }).then(
                    (res) => {
                      if (res.success) {
                        params.forEach((item) => {
                          let index = self.ebCtnRequests.indexOf(item);
                          self.ebCtnRequests.splice(index, 1);
                          self.$coreMethods.message("success", "删除成功！");
                        });
                        self.synchronizeToDetail(true);
                      }
                    }
                );
              }
            },
            function () {
            },
            false,
            "是否删除勾选数据？"
        );
      } else {
        self.$coreMethods.message("warning", self.$t("请勾选你要删除的数据"));
      }
    },
    //同步至明细
    synchronizeToDetail(flag) {
      let self = this;
      let ebCtnRequestDetailData = [];
      self.ebCtnRequestDetails = [];
      if (self.ebCtnRequestDetails && self.ebCtnRequestDetails.length > 0) {
        self.ebCtnRequestDetails.forEach((item) => {
          item.rowStatus = 8;
        });
      }
      self.ebCtnRequestDetailDelete = self.ebCtnRequestDetails;

      self.ebCtnRequests.forEach((item) => {
        for (let i = 0; i < item.ctnQuantity; i++) {
          let ebCtnRequestDetail = {
            ebOrderId: self.ebOrder.ebOrderId,
            ctnSizeType: item.ctnSizeType,
            ctnQuantity: 1,
            ctnCompanyName: item.ctnCompanyName,
            ctnCompanyId: item.ctnCompanyId,
            isSoc: item.isSoc,
            isNor: item.isNor,
            fclLclFlag: item.fclLclFlag,
            rowStatus: 4,
          };
          ebCtnRequestDetailData.push(ebCtnRequestDetail);
        }
      });
      self.ebCtnRequestDetails = ebCtnRequestDetailData;
      self.boxVisible = flag;
      self.ebOrder.synchronizeToDetail = true;
      let containerWidth =
          document.getElementById("boxDiv").clientWidth - 21.22;
      this.$nextTick(() => {
        this.$refs.ebCtnRequestDetailRef.resizeTo(containerWidth);
      });
    },
    //关闭
    /*close() {

      },*/
    // 获取收发通组件中的数据
    getEbPartyInfo(value) {
      console.log("收发通组件数据：", value);
      this.ebParams.ebPartys = value;
    },
    // 获取货物信息组件中的数据
    getEbCargoInfo(value) {
      console.log("货物信息组件数据：", value);
      this.ebParams.ebCargos = value;
    },
    //预配箱信息单元格点击事件
    ebCtnRequestCellClick(row) {
      this._index = row.row;
    },
    //预配箱信息单击行事件
    ebCtnRequestRowClick() {
    },
    //预配箱详情单元格点击事件
    ebCtnRequestDetailCellClick() {
    },
    //预配箱详情单击行事件
    ebCtnRequestDetailRowClick() {
    },
    boxInfoFn() {
      this.boxVisible = true;
      let containerWidth =
          document.getElementById("boxDiv").clientWidth - 21.22;
      this.$nextTick(() => {
        this.$refs.ebCtnRequestRef.resizeTo(containerWidth);
      });
    },
    boxDetailFn() {
      this.boxVisible = false;
      let containerWidth =
          document.getElementById("boxDiv").clientWidth - 21.22;
      this.$nextTick(() => {
        this.$refs.ebCtnRequestDetailRef.resizeTo(containerWidth);
      });
    },
    // 船公司扩展信息
    onChangeCarrier(value, selectedRows) {
      let self = this;
      self.ebOrder.carrierName = selectedRows.custAlias;
      self.ebOrder.carrierId = selectedRows.csCustId;
      console.log(self.ebOrder.carrierId)
    },
    //获取数据字典
    getCarrierSelectList(params) {
      queryDictRows(params).then((res) => {
        this.carrierSelectList = res;
      });
    },
  },
  beforeDestroy() {
    let _this = this;
    // 离开页面删除检测器和所有侦听器
    _this.resizeObserver.disconnect();
  },
  destroyed() {
    sessionStorage.removeItem("ebOrderParams");
    sessionStorage.removeItem("ebOrderType");
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      let _this = vm;
      // _this.$store.state.tagsView.cachedViews[_this.$store.state.tagsView.cachedViews.length - 1] !== 'bookingAdd'
      if (_this.$route.params.type === "add" && _this.bookingCount > 0) {
        _this.bookingCount++;
        _this.$coreMethods.confirm(
            function () {
            },
            function () {
              //订单
              _this.ebOrder = {
                mblTransportTermFrom: "CY",
                mblTransportTermTo: "CY",
                issueMode: "", //正本提单
                noOfOriginal: "3", //THREE(3)
                noOfCopy: "0", //ZERO(0)
                freeApprovalStatus: "",
                custContact: "",
                custContactTel: "",
                custContactEmail: "",
                orderStatus: "NEW",
                bizTypeCode: "",
                bizTypeName: "",
                bizBigTypeCode: "MFE",
                bizBigTypeName: "海运集装箱出口",
                inputMethond: "M",
                orderType: "F",
                isCancelApply: 0,
                // custId: "1",//登录人的委托单位
                // custName: "",//登录人的委托单位
                isLcl: 0,
                // carrierId: "1", //根据对话框中选择的船公司赋值?
                carrierName: "", //根据对话框中选择的船公司赋值?
                isDeleted: 0,
                vgmStatus: "UNSENT",
                vgmApprovalStatus: "NEW",
                transferStatus: 0,
                rowStatus: 4,
                ctnNum: "",
              };
              //货物信息
              _this.ebCargo = {
                ebCargoD: [],
                ebCargoM: {
                  totalFlag: "M",
                  isHazard: 0,
                  isReefer: 0,
                  isBulkyCargo: 0,
                  isDeclare: 0,
                  isOceanPollution: 0,
                  rowStatus: 4,
                },
                //删除的ebCargo
                ebCargoDelete: [],
              };
              //预配箱
              _this.ebCtnRequests = [];
              //预配箱明细
              _this.ebCtnRequestDetails = [];
              //服务项
              _this.ebServiceItems = [];
              //收发通信息
              _this.ebParty = {
                //发货人
                ebPartySH: {
                  partyType: "SH",
                  rowStatus: 4,
                  partyDescription: "",
                },
                //收获人
                ebPartyCN: {
                  partyType: "CN",
                  rowStatus: 4,
                  partyDescription: "",
                },
                //通知人
                ebPartyNT: {
                  partyType: "NT",
                  rowStatus: 4,
                  partyDescription: "",
                },
                //第二通知人
                ebPartyNT2: { partyType: "NT2", rowStatus: 4 },
                //真实发货人
                ebPartyRSH: { partyType: "RSH", rowStatus: 4 },
                //真实收获人
                ebPartyRCN: { partyType: "RCN", rowStatus: 4 },
                //真实通知人
                ebPartyRNT: { partyType: "RNT", rowStatus: 4 },
              };
            },
            false,
            "当前页面有修改，是否先保存？"
        );
      } else {
        _this.bookingCount++;
      }
    });
  },
};
</script>

<style lang="scss">
.redItem .el-form-item__label {
  color: red;
}

.el-scrollbar ::v-deep .el-scrollbar__wrap {
  height: 125px;

  .el-scrollbar__view {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .node-content {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 220px;

      .node-content-img {
        width: 50px;
        background-size: 100% 100%;
      }

      .solid-style {
        height: 1px;
        border-top: 2px solid #e58660;
        width: 173px;
        position: absolute;
        top: 30px;
        left: 134px;
      }

      .dashed-style {
        height: 1px;
        border-top: 2px solid #d7d7d7;
        width: 173px;
        position: absolute;
        top: 30px;
        left: 134px;
      }

      .node-content-name {
        margin-top: 4px;
      }

      .node-content-date {
        font-size: 12px;
        margin-top: 4px;
        width: 80px;
        text-align: center;
        white-space: pre-wrap;
      }
    }
  }
}

.status-container {
  .status-title {
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #ecf4ff;
    border-right: 1px solid #ffffff;
  }

  .status-content-list {
    padding: 6px 0px;

    .status-content-item {
      text-align: center;
    }
  }

  ::v-deep .el-collapse {
    margin-top: 5px;

    .el-collapse-item {
      width: 100%;

      .el-collapse-item__content {
        padding-bottom: 0px;
        background-color: #f2f2f2;
      }

      .el-collapse-item__header {
        font-size: 14px;
        color: #2f5597;
        background-color: #f2f2f2;
        height: 30px;

        .header-icon {
          margin: 3px 0px 0px 3px;
        }
      }
    }
  }
}
</style>
